// CART DRAWER
function openProductmodal() {
  document.getElementById("js-default-menu").classList.add("js-menu__expanded");
  document.getElementById(`main-nav`).classList.add("js-menu__expanded");

  document.addEventListener("click", closeProductModalOnClickOutside);
}

function closeProductModalOnClickOutside(event) {
  var cart = document.getElementById("main-nav");
  var isClickInsideCart = cart.contains(event.target);
  if (!isClickInsideCart) {
    closeProductmodal();
  }
}

function closeProductmodal() {
  document
    .getElementById("js-default-menu")
    .classList.remove("js-menu__expanded");
  document.getElementById(`main-nav`).classList.remove("js-menu__expanded");
}

function openVariantModal() {
  document.getElementById("variant_modal").classList.add("visible");
  // document.getElementById(`main-nav_variant`).classList.add('js-menu__expanded_variant')
}

function closeVariantModal() {
  document.getElementById("variant_modal").classList.remove("visible");
  // document.getElementById(`main-nav_variant`).classList.remove('js-menu__expanded_variant')
}

function openCustomCart() {
  document
    .getElementById("custom_cart_cart")
    .classList.add("js-menu__expanded_cart");
  document
    .getElementById(`main-nav-cart`)
    .classList.add("js-menu__expanded_cart");
  document.addEventListener("click", closeCustomCartOnClickOutside);
}

function closeCustomCartOnClickOutside(event) {
  var cart = document.getElementById("main-nav-cart");
  var productsModal = document.getElementById("js-default-menu");

  if(productsModal.contains(event.target)){
    return 
  } 
  
  var isClickInsideCart = cart.contains(event.target);
  if (!isClickInsideCart ) {
    closeCustomCart();
  }
}

function closeCustomCart() {
  document
    .getElementById("custom_cart_cart")
    .classList.remove("js-menu__expanded_cart");
  document
    .getElementById(`main-nav-cart`)
    .classList.remove("js-menu__expanded_cart");
}
var dynamic_quantity_selector = ({ metafields }) => {
  console.log("metafields",metafields);
  if(!Array.isArray(metafields)){
    metafields= Object.keys(metafields).map(key=>metafields[key])
  }
  const multiple = Number(
    metafields.find((item) => item?.key == "quantity_multiple")?.value || 10
  );
  const unit =
    metafields.find((item) => item?.key == "quantity_unit")?.value || "";
  let localMultiple = 1;
  const quantitySelector = [];
  let i;
  for (i = 1; i <= 1000; i++) {
    localMultiple = multiple * i;
    quantitySelector.push({
      name: `${localMultiple} ${unit}`,
      quantity: localMultiple,
    });
    if (localMultiple >= 1000) {
      break;
    }
  }
  return quantitySelector;
};

var quant_select = [
  { name: "10 sqft", quantity: 10 },
  { name: "20 sqft", quantity: 20 },
  { name: "30 sqft", quantity: 30 },
  { name: "40 sqft", quantity: 40 },
  { name: "50 sqft", quantity: 50 },
  { name: "60 sqft", quantity: 60 },
  { name: "70 sqft", quantity: 70 },
  { name: "80 sqft", quantity: 80 },
  { name: "90 sqft", quantity: 90 },
  { name: "100 sqft", quantity: 100 },
  { name: "110 sqft", quantity: 110 },
  { name: "120 sqft", quantity: 120 },
  { name: "130 sqft", quantity: 130 },
  { name: "140 sqft", quantity: 140 },
  { name: "150 sqft", quantity: 150 },
  { name: "160 sqft", quantity: 160 },
  { name: "170 sqft", quantity: 170 },
  { name: "180 sqft", quantity: 180 },
  { name: "190 sqft", quantity: 190 },
  { name: "200 sqft", quantity: 200 },
  { name: "210 sqft", quantity: 210 },
  { name: "220 sqft", quantity: 220 },
  { name: "230 sqft", quantity: 230 },
  { name: "240 sqft", quantity: 240 },
  { name: "250 sqft", quantity: 250 },
  { name: "260 sqft", quantity: 260 },
  { name: "270 sqft", quantity: 270 },
  { name: "280 sqft", quantity: 280 },
  { name: "290 sqft", quantity: 290 },
  { name: "300 sqft", quantity: 300 },
  { name: "310 sqft", quantity: 310 },
  { name: "320 sqft", quantity: 320 },
  { name: "330 sqft", quantity: 330 },
  { name: "340 sqft", quantity: 340 },
  { name: "350 sqft", quantity: 350 },
  { name: "360 sqft", quantity: 360 },
  { name: "370 sqft", quantity: 370 },
  { name: "380 sqft", quantity: 380 },
  { name: "390 sqft", quantity: 390 },
  { name: "400 sqft", quantity: 400 },
  { name: "410 sqft", quantity: 410 },
  { name: "420 sqft", quantity: 420 },
  { name: "430 sqft", quantity: 430 },
  { name: "440 sqft", quantity: 440 },
  { name: "450 sqft", quantity: 450 },
  { name: "460 sqft", quantity: 460 },
  { name: "470 sqft", quantity: 470 },
  { name: "480 sqft", quantity: 480 },
  { name: "490 sqft", quantity: 490 },
  { name: "500 sqft", quantity: 500 },
  { name: "510 sqft", quantity: 510 },
  { name: "520 sqft", quantity: 520 },
  { name: "530 sqft", quantity: 530 },
  { name: "540 sqft", quantity: 540 },
  { name: "550 sqft", quantity: 550 },
  { name: "560 sqft", quantity: 560 },
  { name: "570 sqft", quantity: 570 },
  { name: "580 sqft", quantity: 580 },
  { name: "590 sqft", quantity: 590 },
  { name: "600 sqft", quantity: 600 },
  { name: "610 sqft", quantity: 610 },
  { name: "620 sqft", quantity: 620 },
  { name: "630 sqft", quantity: 630 },
  { name: "640 sqft", quantity: 640 },
  { name: "650 sqft", quantity: 650 },
  { name: "660 sqft", quantity: 660 },
  { name: "670 sqft", quantity: 670 },
  { name: "680 sqft", quantity: 680 },
  { name: "690 sqft", quantity: 690 },
  { name: "700 sqft", quantity: 700 },
  { name: "710 sqft", quantity: 710 },
  { name: "720 sqft", quantity: 720 },
  { name: "730 sqft", quantity: 730 },
  { name: "740 sqft", quantity: 740 },
  { name: "750 sqft", quantity: 750 },
  { name: "760 sqft", quantity: 760 },
  { name: "770 sqft", quantity: 770 },
  { name: "780 sqft", quantity: 780 },
  { name: "790 sqft", quantity: 790 },
  { name: "800 sqft", quantity: 800 },
  { name: "810 sqft", quantity: 810 },
  { name: "820 sqft", quantity: 820 },
  { name: "830 sqft", quantity: 830 },
  { name: "840 sqft", quantity: 840 },
  { name: "850 sqft", quantity: 850 },
  { name: "860 sqft", quantity: 860 },
  { name: "870 sqft", quantity: 870 },
  { name: "880 sqft", quantity: 880 },
  { name: "890 sqft", quantity: 890 },
  { name: "900 sqft", quantity: 900 },
  { name: "910 sqft", quantity: 910 },
  { name: "920 sqft", quantity: 920 },
  { name: "930 sqft", quantity: 930 },
  { name: "940 sqft", quantity: 940 },
  { name: "950 sqft", quantity: 950 },
  { name: "960 sqft", quantity: 960 },
  { name: "970 sqft", quantity: 970 },
  { name: "980 sqft", quantity: 980 },
  { name: "990 sqft", quantity: 990 },
  { name: "1000 sqft", quantity: 1000 },
];

var sample_quantity = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
  42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
  61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 78, 79, 80,
  81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
  100,
];

var quantity_fanwall = [
  10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170,
  180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320,
  330, 340, 350, 360, 370, 380, 390, 400, 410, 420, 430, 440, 450, 460, 470,
  480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600, 610, 620,
  630, 640, 650, 660, 670, 680, 690, 700, 710, 720, 730, 740, 750, 760, 780,
  790, 800, 810, 820, 830, 840, 850, 860, 870, 880, 890, 900, 910, 920, 930,
  940, 950, 960, 970, 980, 990, 1000,
];

var img_desc = [
  {
    title: "5 Inch Wide",
    desc: "All Planks will be 5 inches wide. Standard Option.",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 56H56V4H4" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M4 56H56" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "1 to 4 Foot Random Lengths",
    desc: "Planks will be 1 foot to 4 foot in length. This will give your wall a classic staggered look. Standard Option.",
    imgURL: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M53 1H1V53H53V1Z" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M53 40H1" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M53 14H1" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M1 27H53" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M40 1V14" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M27 40V27" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M14 53V40" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "4 Foot Lengths",
    desc: "All boards will be 4 feet long. This is often requested when designing a chevron or herringbone wall pattern. +$3 / Square Foot.",
    imgURL: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M53 1H1V53H53V1Z" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M53 40H1" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M53 14H1" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M1 27H53" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "No Treatment",
    desc: "Your planks will come with the usual beautiful finish but no option treatments. Standard Option.",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">

<path d="M54.9166 28.332C53.6206 29.4327 52.218 30.4181 50.7356 31.2525C47.5311 33.0456 44.0159 34.2084 40.4297 34.9363C36.95 35.6465 33.1597 35.2825 29.8486 36.6851C28.1265 37.4129 26.5287 38.4071 24.9487 39.4102C21.9927 41.2832 19.0634 43.2006 16.1607 45.1623C14.9179 45.9968 13.7018 46.8933 12.4502 47.7455" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M23.4932 54.1089C27.9848 50.212 28.7216 49.6705 29.7424 49.0669C30.9585 48.3567 34.6779 46.4127 39.6133 45.9156C41.1313 45.7647 41.5307 45.8712 43.5014 45.6493C43.5014 45.6493 46.9278 45.2676 50.5584 44.1758" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M54.0916 36.5781C49.7598 38.7263 45.8451 39.5518 44.1585 39.9069C37.7318 41.2562 36.8796 39.7116 32.0773 41.6379C27.7365 43.3866 24.3723 46.2804 19.1083 50.8253C18.6823 51.1892 18.2917 51.5354 17.9277 51.855" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M31.8462 24.0797C29.2719 22.8547 26.9639 21.7452 24.221 20.9019C21.8687 20.174 14.6697 17.9637 7.47948 20.7421C7.2043 20.8486 6.94688 20.9551 6.68945 21.0705" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M31.8457 24.0795C31.9256 24.115 31.9966 24.1505 32.0854 24.1949C34.9437 25.553 38.015 26.6271 41.2107 26.6449C45.7201 26.6804 49.9543 24.6565 53.6914 22.0645" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M33.861 19.2058C32.1656 18.3093 30.5322 17.2884 28.7391 16.5872C26.5821 15.7439 20.1376 13.0986 12.9651 14.0839C12.0597 14.2082 11.1898 14.3769 10.3643 14.5722" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M33.8613 19.2062C34.8822 19.7477 35.9207 20.2448 37.0303 20.6087C39.5424 21.4254 42.3386 21.6562 44.8064 20.7153C47.1587 19.8187 49.1471 18.2387 51.2686 16.916" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M34.1277 13.7731C32.9028 13.134 31.7044 12.4327 30.4794 11.7936C26.8754 9.91169 22.6235 8.56243 18.2295 7.97656" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M34.1279 13.7727C35.1843 14.3231 36.2495 14.8291 37.3768 15.2196C40.031 16.1251 43.2266 16.0984 45.6411 14.4474C46.4755 13.8793 47.1146 13.1602 47.6739 12.3613" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M8.98833 43.4918C9.91151 43.1101 10.8347 42.6574 11.7046 42.107C16.5424 39.0534 21.7531 33.5765 27.1413 32.1029C33.3639 30.3986 39.5687 30.8158 39.5687 30.8158C37.5537 30.1855 32.2188 31.0288 26.2181 27.1497C21.1228 23.8564 11.1187 23.8653 5.04705 29.36C5.03817 29.573 5.0293 29.7772 5.0293 29.9902" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M6.62793 38.797C7.4801 38.4863 8.3589 38.1224 9.24657 37.6697C11.1817 36.6843 12.1404 35.8055 13.5607 34.696C15.1052 33.4887 17.5019 31.7666 20.9816 29.7871" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M21.0434 29.7695C20.0225 29.8139 18.5756 29.9204 16.8535 30.1956C14.4657 30.5773 11.3056 31.0744 8.34073 32.6722C7.06248 33.3646 6.14818 34.0747 5.48242 34.7139" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M46.2138 49.0042C56.7081 40.0494 57.9562 24.2829 49.0015 13.7885C40.0467 3.29421 24.2802 2.04612 13.7858 11.0009C3.29151 19.9556 2.04343 35.7222 10.9982 46.2165C19.9529 56.7108 35.7195 57.9589 46.2138 49.0042Z" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>

<defs>
<clipPath id="clip-treatment">
<rect width="52" height="52" fill="white" transform="translate(4 4)"></rect>
</clipPath>
</defs>
</svg>`,
  },
  {
    title: "Class A Fire Rating",
    desc: "Coat your planks with a Class-A fire treatment, built for the demands of a commercial environment. +$1.25 / Square Foot.",
    imgURL: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.2975 41.8644C13.0412 37.2346 12.3297 26.635 20.388 20.5728C26.1914 16.2017 26.4779 8.89195 26.4779 8.89195C26.4779 8.89195 31.1262 11.5257 31.1262 17.3199C31.1262 23.1049 28.0027 26.9307 25.3597 29.9156C19.9813 36.0055 19.2975 41.8644 19.2975 41.8644ZM23.7148 43.842C24.5834 44.0268 25.5076 44.1285 26.4871 44.1285C38.6762 44.1285 40.4043 31.7361 37.0498 26.5056C35.7837 24.5372 34.7764 19.1404 34.7764 19.1404C34.7764 19.1404 35.1184 22.3933 33.4919 25.8402C31.8655 29.2964 28.4093 32.9467 26.1822 36.1996C23.9458 39.4617 23.7148 43.842 23.7148 43.842ZM8.62396 8.62396L45.376 45.3668L8.62396 8.62396ZM53 27.0046C53 41.3654 41.3654 53 26.9954 53C12.6346 53 1 41.3654 1 27.0046C1 12.6439 12.6439 1 27.0046 1C41.3654 1 53 12.6439 53 27.0046Z" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },

  {
    title: "40 Inch Lengths",
    desc: "These planks are 40 inches long making assembly of the pattern easy.",
    imgURL: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M53 1H1V53H53V1Z" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M53 40H1" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M53 14H1" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M1 27H53" stroke="#372E2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Splash Safe",
    desc: "The ideal add-on when incorporating authentic materials in spaces such as bathrooms or backsplashes.",
    imgURL: `<svg width="45" height="53" viewBox="0 0 45 53" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.23981 9.625C8.23981 17.3089 0.950195 25.4513 0.950195 32.8051C0.950195 37.1605 4.22364 40.709 8.23981 40.709C12.256 40.709 15.5294 37.1605 15.5294 32.8051C15.5294 25.4513 8.23981 17.3181 8.23981 9.625Z" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M22.9108 1.29883C22.9108 6.30528 18.1611 11.6052 18.1611 16.3915C18.1611 19.2249 20.2884 21.5355 22.9108 21.5355C25.5333 21.5355 27.6606 19.2249 27.6606 16.3915C27.6606 11.6052 22.9108 6.30528 22.9108 1.29883Z" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M34.7667 12.668C34.7667 22.4058 25.5332 32.7121 25.5332 42.0282C25.5332 47.5481 29.6777 52.0411 34.7667 52.0411C39.8557 52.0411 44.0002 47.5481 44.0002 42.0282C44.0094 32.7213 34.7667 22.415 34.7667 12.668Z" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Splash Safe & Class A Fire Rating",
    desc: "A combination of both our Splash Safe and Class A Fire Rating Coatings.",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34 5C34 9.20571 30 13.6579 30 17.6788C30 20.0589 31.7915 22 34 22C36.2085 22 38 20.0589 38 17.6788C38 13.6579 34 9.20571 34 5Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M45.5 18C45.5 26.4089 38 35.3088 38 43.3535C38 48.1202 41.3664 52 45.5 52C49.6336 52 53 48.1202 53 43.3535C53.0074 35.3167 45.5 26.4169 45.5 18Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M15.5006 45.2181C12.2522 42.8141 11.8827 37.3105 16.0668 34.1628C19.0802 31.8932 19.2289 28.0977 19.2289 28.0977C19.2289 28.0977 21.6424 29.4653 21.6424 32.4738C21.6424 35.4775 20.0206 37.464 18.6483 39.0139C15.8557 42.1759 15.5006 45.2181 15.5006 45.2181ZM17.7942 46.2449C18.2452 46.3409 18.7251 46.3936 19.2337 46.3936C25.5626 46.3936 26.4599 39.9591 24.7181 37.2433C24.0608 36.2213 23.5378 33.4191 23.5378 33.4191C23.5378 33.4191 23.7153 35.1081 22.8708 36.8978C22.0263 38.6924 20.2317 40.5877 19.0754 42.2767C17.9142 43.9705 17.7942 46.2449 17.7942 46.2449ZM9.95859 27.9586L29.0414 47.0366L9.95859 27.9586ZM33 37.5024C33 44.9589 26.959 51 19.4976 51C12.0411 51 6 44.9589 6 37.5024C6 30.0459 12.0459 24 19.5024 24C26.9589 24 33 30.0459 33 37.5024Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Reclaimed Weathered Wood",
    desc: "Your Purchase will come with Reclaimed Weathered Wood Planks.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/e029a4fc-016d-4ea2-b9a4-43716e3c7a81/' />`,
  },
  {
    title: "Reclaimed Weathered Wood White",
    desc: "Your Purchase will come with Reclaimed Weathered Wood White Planks.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/e35aad72-3105-4a57-b30a-a9b02ec20bdd/' />`,
  },
  {
    title: "Reclaimed Weathered Wood Gray",
    desc: "Your Stikit will come with Reclaimed Weathered Wood Planks.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/4049a751-8320-4602-b27c-1c63e58d263c/' />`,
  },
  {
    title: "Reclaimed Sierra Silver",
    desc: "Your Purchase will come with Reclaimed Sierra Silver Planks.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/e66f111c-0d2a-4e01-af5a-aab226aefe4e/' />`,
  },
  {
    title: "Horizontal",
    desc: "Planks will be placed in horizontal lines from left to right.",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M56 4H4V56H56V4Z" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M56 43H4" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M56 17H4" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M4 30H56" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M43 4V17" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M30 43V30" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M17 56V43" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "King Size",
    desc: "Fits king size beds. Measures 35 inches tall x 80 inches wide and is 1.5 inches deep. <br/> $449",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50 14H10V31H50V14Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M10 31L2 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M50 31L58 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M9.32001 38H37.4" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Queen Size",
    desc: "Fits queen size beds. Measures 35 inches tall x 64 inches wide and is 1.5 inches deep. <br/> $399",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.68 14H12.32V31H47.68V14Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.32 31L4 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.68 31L56 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.32 38H40.4" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Minimalist Fir",
    desc: "Your Stikit will come with Reclaimed Minimalist Fir Planks.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/d71470a7-c895-4f89-b187-d13dd75976be/' />`,
  },
  {
    title: "Modern White",
    desc: "Your Stikit will come with Modern White Wood Planks.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/b46b15e8-f8e1-4174-91c8-f845091dae92/' />`,
  },
  {
    title: "Full Size",
    desc: "Fits full size beds. Measures 31.5 inches tall x 56 inches wide and is 1.5 inches deep. <br/> $315",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.68 14H12.32V31H47.68V14Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.32 31L4 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.68 31L56 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.32 38H40.4" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Twin Size",
    desc: "Fits twin size beds. Measures 31.5 inches tall x 42 inches wide and is 1.5 inches deep. <br/> $240",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.68 14H12.32V31H47.68V14Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.32 31L4 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.68 31L56 38.5566V47" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.32 38H40.4" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "College-East Lansing-Michigan",
    desc: "Your fanwall headboard will come in East Lansing Black Green and White.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/c6a09236-48dc-4e8a-83ee-3c0b2c272086/' />`,
  },
  {
    title: "College-Ann Arbor-Michigan",
    desc: "Your fanwall headboard will come in Ann Arbor Blue, Yellow and White.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/33ef321e-0738-4f0d-a78d-e39d9aa1dbb5/' />`,
  },
  {
    title: "Custom-Tell Us Your Teams Colors",
    desc: "Your fanwall headboard will come in your team's colors. Just let us know who you root for (or we will reach out and ask) and we will customize your headboard.",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M58 30.5038L12.2737 48V13L58 30.5038Z" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.2737 16.8923H2" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M12.2737 44.1154H2" stroke="black" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "10 Inches",
    desc: "Shelf will be 10 inches wide and 1.5 inches Tall",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M57 33.44H3V45H57V33.44Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.84 18.64V17.31C21.2722 17.2989 21.7032 17.2588 22.13 17.19C22.5087 17.123 22.8577 16.9415 23.13 16.67C23.3092 16.4655 23.4392 16.2226 23.51 15.96C23.5505 15.8302 23.574 15.6958 23.58 15.56H25.21V25.47H23.21V18.64H20.84Z" fill="#231F20"></path>
<path d="M34.17 16.82C34.7402 17.9986 35.0017 19.3027 34.93 20.61C35.0045 21.9143 34.7428 23.2158 34.17 24.39C33.8607 24.802 33.4598 25.1363 32.999 25.3665C32.5382 25.5968 32.0301 25.7167 31.515 25.7167C30.9999 25.7167 30.4918 25.5968 30.031 25.3665C29.5702 25.1363 29.1693 24.802 28.86 24.39C28.2872 23.2158 28.0256 21.9143 28.1 20.61C28.0283 19.3027 28.2898 17.9986 28.86 16.82C29.1693 16.4081 29.5702 16.0737 30.031 15.8435C30.4918 15.6132 30.9999 15.4933 31.515 15.4933C32.0301 15.4933 32.5382 15.6132 32.999 15.8435C33.4598 16.0737 33.8607 16.4081 34.17 16.82V16.82ZM30.37 23.23C30.4295 23.4878 30.5747 23.7177 30.7817 23.8824C30.9887 24.0471 31.2455 24.1367 31.51 24.1367C31.7746 24.1367 32.0313 24.0471 32.2383 23.8824C32.4454 23.7177 32.5905 23.4878 32.65 23.23C32.8581 22.3729 32.9489 21.4915 32.92 20.61C32.9542 19.7184 32.8634 18.8264 32.65 17.96C32.5766 17.7147 32.426 17.4997 32.2206 17.3468C32.0152 17.1939 31.766 17.1113 31.51 17.1113C31.254 17.1113 31.0048 17.1939 30.7994 17.3468C30.594 17.4997 30.4434 17.7147 30.37 17.96C30.1471 18.8248 30.0528 19.7177 30.09 20.61C30.0584 21.4922 30.1527 22.3744 30.37 23.23Z" fill="#231F20"></path>
<path d="M38.15 15L36.48 17H35.14L36.14 15H38.15ZM39.15 15H41.15L39.48 17H38.14L39.15 15Z" fill="#231F20"></path>
</svg>`,
  },
  {
    title: "Smooth Gray",
    desc: "A beautiful gray wash will be applied to your smooth wood shelf that showcases the grain of the reclaimed wood.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1920/https://f.shgcdn.com/bb475a57-4fb6-4940-8a43-628a58254232/' />`,
  },
  {
    title: "Smooth Brown",
    desc: "A beautiful brown wash will be applied to your smooth wood shelf that showcases the grain of the reclaimed wood.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1200/https://f.shgcdn.com/793a66ca-a3b4-4ade-bf6a-f10f536f9c50/' />`,
  },
  {
    title: "Textured Brown",
    desc: "A beautiful brown wash will be applied to your rough wood shelf that showcases the grain of the reclaimed wood.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1200/https://f.shgcdn.com/0a29f77e-71da-45a9-80b2-a8c66d3ea8ae/' />`,
  },
  {
    title: "Smooth Black",
    desc: "A beautiful brown wash will be applied to your rough wood shelf that showcases the grain of the reclaimed wood.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1200/https://f.shgcdn.com/5e29ff47-22a7-41b8-825b-bd21ca883276/' />`,
  },
  {
    title: "Smooth White",
    desc: "A beautiful brown wash will be applied to your rough wood shelf that showcases the grain of the reclaimed wood.",
    imgURL: `<img src='https://res.cloudinary.com/shogun-frontend/image/fetch/f_auto,q_auto,c_limit,w_1200/https://f.shgcdn.com/018651e6-b25c-4555-8625-9a9f35e94300/' />`,
  },
  {
    title: "No Hardware",
    desc: "No hardware will be included with the kit. With this option you will be responsible for supplying the hardware.",
    imgURL: `<img src='https://dummyimage.com/4:3x810/c2c2c2/fff.jpg' />`,
  },
  {
    title: "Include Hardware",
    desc: "Black barn door hardware will be supplied with your kit.",
    imgURL: `<img src='https://dummyimage.com/4:3x810/c2c2c2/fff.jpg' />`,
  },
  {
    title: "Black Metal J Brackets (Set of 3)",
    desc: "Shelf will come with 3 satin black metal 'J' brackets. <br/> $16",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.3 48.642V16.9854L38.4636 12V43.6501" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.8363 42.3146V48.642L12 43.6501V37.3226L20.8363 42.3146Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.8428 43.6501H38.4636" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 48.642H20.8428" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 48.642L38.4636 43.6501" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8851 38.4118C42.2012 38.4118 41.6468 37.8574 41.6468 37.1735C41.6468 36.4897 42.2012 35.9353 42.8851 35.9353C43.5689 35.9353 44.1233 36.4897 44.1233 37.1735C44.1233 37.8574 43.5689 38.4118 42.8851 38.4118Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8851 24.7002C42.2012 24.7002 41.6468 24.1458 41.6468 23.462C41.6468 22.7781 42.2012 22.2237 42.8851 22.2237C43.5689 22.2237 44.1233 22.7781 44.1233 23.462C44.1233 24.1458 43.5689 24.7002 42.8851 24.7002Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Black Metal Shelf Brackets (Set of 3)",
    desc: "Shelf will come with 3 satin black metal wall brackets.<br/> $16",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.3 20.3156V50.5298L38.4684 45.5421V20.3156" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.8381 13.9878V20.3156L12 15.3213V9L20.8381 13.9878Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.838 15.3213H38.4684" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 20.3156H20.838" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 20.3156L38.4684 15.3213" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8875 41.0054C42.2052 41.0054 41.652 40.4522 41.652 39.7699C41.652 39.0875 42.2052 38.5344 42.8875 38.5344C43.5699 38.5344 44.123 39.0875 44.123 39.7699C44.123 40.4522 43.5699 41.0054 42.8875 41.0054Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8875 27.2906C42.2052 27.2906 41.652 26.7375 41.652 26.0551C41.652 25.3728 42.2052 24.8196 42.8875 24.8196C43.5699 24.8196 44.123 25.3728 44.123 26.0551C44.123 26.7375 43.5699 27.2906 42.8875 27.2906Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },

  {
    title: "Rustic Pipe Shelf Brackets (Set of 3)",
    desc: "Your shelf will come with 3 rustic pipe brackets.<br/> $16",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3411 35.0422L46.1183 35.0422" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M46.1183 25.3313L11.3411 25.3313" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M11.3411 25.3313C10.0482 25.3313 9 27.5052 9 30.1868C9 32.8684 10.0482 35.0422 11.3411 35.0422C12.6341 35.0422 13.6823 32.8684 13.6823 30.1868C13.6823 27.5052 12.6341 25.3313 11.3411 25.3313Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M40.6984 25.4467C41.5899 21.0723 43.6809 18 46.1183 18C49.3702 18 52 23.4584 52 30.1868C52 36.9151 49.3702 42.3735 46.1183 42.3735C43.7066 42.3735 41.6284 39.3589 40.724 35.0422" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M14.6893 25.3377C15.9721 25.3377 17.0304 27.5121 17.0304 30.1932C17.0304 32.8743 15.9849 35.0486 14.6893 35.0486" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M46.1183 25.3377C47.4011 25.3377 48.4594 27.5121 48.4594 30.1932C48.4594 32.8743 47.4139 35.0486 46.1183 35.0486" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Rustic Pipe Shelf Brackets (Set of 2)",
    desc: "Your shelf will come with 2 rustic pipe brackets.<br/> $16",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3411 35.0422L46.1183 35.0422" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M46.1183 25.3313L11.3411 25.3313" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M11.3411 25.3313C10.0482 25.3313 9 27.5052 9 30.1868C9 32.8684 10.0482 35.0422 11.3411 35.0422C12.6341 35.0422 13.6823 32.8684 13.6823 30.1868C13.6823 27.5052 12.6341 25.3313 11.3411 25.3313Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M40.6984 25.4467C41.5899 21.0723 43.6809 18 46.1183 18C49.3702 18 52 23.4584 52 30.1868C52 36.9151 49.3702 42.3735 46.1183 42.3735C43.7066 42.3735 41.6284 39.3589 40.724 35.0422" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M14.6893 25.3377C15.9721 25.3377 17.0304 27.5121 17.0304 30.1932C17.0304 32.8743 15.9849 35.0486 14.6893 35.0486" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M46.1183 25.3377C47.4011 25.3377 48.4594 27.5121 48.4594 30.1932C48.4594 32.8743 47.4139 35.0486 46.1183 35.0486" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "5.5 inch Wide Shelf",
    desc: "Shelf will be 5.5 Inches Wide and 1.5 Inches Tall. <br/> $16",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M57 31.66H3V45.89H57V31.66Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.24 21.84C20.2833 22.2099 20.4365 22.5582 20.68 22.84C20.8117 22.9669 20.9692 23.0639 21.1418 23.1243C21.3144 23.1847 21.4979 23.2071 21.68 23.19C21.8912 23.2025 22.1022 23.1625 22.2942 23.0735C22.4862 22.9845 22.6531 22.8493 22.78 22.68C23.0419 22.3057 23.1752 21.8566 23.16 21.4C23.1756 20.9463 23.0498 20.4991 22.8 20.12C22.6786 19.9436 22.5133 19.8018 22.3204 19.7089C22.1275 19.6159 21.9136 19.5749 21.7 19.59C21.4898 19.586 21.2804 19.6164 21.08 19.68C20.7823 19.7907 20.5363 20.0081 20.39 20.29L18.65 20.21L19.34 14.73H24.8V16.39H20.75L20.39 18.56C20.611 18.4033 20.8492 18.2725 21.1 18.17C21.4209 18.0568 21.7597 18.0026 22.1 18.01C22.5191 18.0004 22.9356 18.0787 23.3226 18.2399C23.7095 18.4011 24.0584 18.6417 24.3467 18.946C24.6351 19.2503 24.8564 19.6117 24.9965 20.0068C25.1365 20.4019 25.1922 20.822 25.16 21.24C25.1649 22.1379 24.8533 23.0089 24.28 23.7C23.953 24.0713 23.5445 24.362 23.0865 24.5493C22.6286 24.7367 22.1335 24.8156 21.64 24.78C20.8008 24.8115 19.9779 24.542 19.32 24.02C19.0148 23.7472 18.7686 23.4149 18.5966 23.0434C18.4246 22.672 18.3305 22.2692 18.32 21.86L20.24 21.84Z" fill="#231F20"></path>
<path d="M26.59 22.45H28.66V24.5H26.59V22.45Z" fill="#231F20"></path>
<path d="M31.91 21.84C31.9567 22.2108 32.1134 22.5591 32.36 22.84C32.4852 22.9614 32.6344 23.0552 32.798 23.1155C32.9616 23.1758 33.136 23.2011 33.31 23.19C33.5212 23.2025 33.7323 23.1625 33.9242 23.0735C34.1162 22.9845 34.2831 22.8493 34.41 22.68C34.6796 22.3095 34.8137 21.8576 34.79 21.4C34.8034 20.948 34.6816 20.5023 34.44 20.12C34.3157 19.9442 34.1484 19.8031 33.9541 19.7104C33.7597 19.6176 33.5449 19.5761 33.33 19.59C33.1231 19.586 32.9169 19.6165 32.72 19.68C32.4191 19.7854 32.1715 20.0043 32.03 20.29L30.28 20.21L30.98 14.73H36.43V16.39H32.43L32.07 18.56C32.2878 18.4038 32.5226 18.273 32.77 18.17C33.0914 18.0584 33.4299 18.0043 33.77 18.01C34.1891 18.0004 34.6056 18.0787 34.9926 18.2399C35.3795 18.4011 35.7284 18.6417 36.0167 18.946C36.3051 19.2503 36.5264 19.6117 36.6665 20.0068C36.8065 20.4019 36.8622 20.822 36.83 21.24C36.8393 22.1387 36.5272 23.0111 35.95 23.7C35.625 24.0711 35.2183 24.3618 34.762 24.5492C34.3056 24.7366 33.812 24.8156 33.32 24.78C32.4777 24.8113 31.6518 24.5419 30.99 24.02C30.6848 23.7472 30.4386 23.4149 30.2666 23.0434C30.0946 22.672 30.0005 22.2692 29.99 21.86L31.91 21.84Z" fill="#231F20"></path>
<path d="M40.09 14L38.42 16H37.08L38.08 14H40.09ZM41.09 14H43.09L41.42 16H40.08L41.09 14Z" fill="#231F20"></path>
</svg>`,
  },
  {
    title: "Black Metal J Brackets (Set of 2)",
    desc: "Shelf will come with 2 satin black metal 'J' brackets. <br/> $16",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.3 48.642V16.9854L38.4636 12V43.6501" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.8363 42.3146V48.642L12 43.6501V37.3226L20.8363 42.3146Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.8428 43.6501H38.4636" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 48.642H20.8428" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 48.642L38.4636 43.6501" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8851 38.4118C42.2012 38.4118 41.6468 37.8574 41.6468 37.1735C41.6468 36.4897 42.2012 35.9353 42.8851 35.9353C43.5689 35.9353 44.1233 36.4897 44.1233 37.1735C44.1233 37.8574 43.5689 38.4118 42.8851 38.4118Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8851 24.7002C42.2012 24.7002 41.6468 24.1458 41.6468 23.462C41.6468 22.7781 42.2012 22.2237 42.8851 22.2237C43.5689 22.2237 44.1233 22.7781 44.1233 23.462C44.1233 24.1458 43.5689 24.7002 42.8851 24.7002Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Black Metal Shelf Brackets (Set of 2)",
    desc: "Shelf will come with 2 satin black metal wall brackets. <br/> $16",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.3 20.3156V50.5298L38.4684 45.5421V20.3156" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.8381 13.9878V20.3156L12 15.3213V9L20.8381 13.9878Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M20.838 15.3213H38.4684" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 20.3156H20.838" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M47.3 20.3156L38.4684 15.3213" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8875 41.0054C42.2052 41.0054 41.652 40.4522 41.652 39.7699C41.652 39.0875 42.2052 38.5344 42.8875 38.5344C43.5699 38.5344 44.123 39.0875 44.123 39.7699C44.123 40.4522 43.5699 41.0054 42.8875 41.0054Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M42.8875 27.2906C42.2052 27.2906 41.652 26.7375 41.652 26.0551C41.652 25.3728 42.2052 24.8196 42.8875 24.8196C43.5699 24.8196 44.123 25.3728 44.123 26.0551C44.123 26.7375 43.5699 27.2906 42.8875 27.2906Z" stroke="#372E2D" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
  {
    title: "Vertical",
    desc: "Planks will be placed in vertical lines from top to bottom.",
    imgURL: `<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M56 56L56 4L4 4L4 56L56 56Z" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M17 56L17 4" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M43 56L43 4" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M30 4L30 56" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M56 43L43 43" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M17 30L30 30" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M4 17L17 17" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`,
  },
];

// CUSTOM PRODUCT DATA
var DISCOUNT_TYPE;
var SELECTED_PRODUCT = {
  product_data: {},
  cart_product_data: {},
  options_to_update: [],
  productObjToUpdate: {},
};

async function setupProductModal(
  id,
  productToUpdate = {},
  variant_options = [],
  trade_percent,
  trade_type
) {
  
  console.log("tradsaddas", trade_percent,trade_type,typeof trade_type,typeof trade_type !=undefined);
  //applied this check becuase trade_type is giving undefined in string
  if(trade_type !="undefined"){
    DISCOUNT_TYPE = trade_type;
    console.log("Discount Tyoe2",DISCOUNT_TYPE)
  }
  else{
    DISCOUNT_TYPE = String(document.getElementById("trade_discount_type")?.innerText)?.trim() || "";
    console.log("Discount Tyoe",DISCOUNT_TYPE) 
  }
  
  SELECTED_PRODUCT.productObjToUpdate = productToUpdate;
  SELECTED_PRODUCT.options_to_update = variant_options;
  await getProductData(id);
  if (Object.keys(SELECTED_PRODUCT.product_data).length != 0) {
    if (SELECTED_PRODUCT.product_data.options[0].values[0] != "Default Title") {
      productDataMapOnModal(trade_percent);
      QuanitySelectorForMappedProductData({}, trade_percent);
    } else {
      mapSampleProductDataOnModal(trade_percent);
    }
  } else {
    console.log("Data does not come from Graph QL Api ");
  }
}

async function getProductData(id) {
  const query = {
    query: `{
    product(id: "gid://shopify/Product/${id}") {
    
      
      metafields(identifiers: 
            [
              {namespace: "custom", key: "option_1_name_and_desc"},
              {namespace: "custom", key: "option_1_image"},
              {namespace: "custom", key: "option_2_name_and_desc"},
              {namespace: "custom", key: "option_2_image"},
              {namespace: "custom", key: "option_3_name_and_desc"},
              {namespace: "custom", key: "option_3_image"},
              {namespace: "custom", key: "option_4_name_and_desc"},
              {namespace: "custom", key: "option_4_image"},
              {namespace: "custom", key: "option_5_name_and_desc"},
              {namespace: "custom", key: "option_5_image"},
              {namespace: "custom", key: "option_6_name_and_desc"},
              {namespace: "custom", key: "option_6_image"},
              {namespace: "custom", key: "option_7_name_and_desc"},
              {namespace: "custom", key: "option_7_image"},
              {namespace: "custom", key: "option_8_name_and_desc"},
              {namespace: "custom", key: "option_8_image"},
              {namespace: "custom", key: "option_9_name_and_desc"},
              {namespace: "custom", key: "option_9_image"},
              {namespace: "custom", key: "option_10_name_and_desc"},
              {namespace: "custom", key: "option_10_image"},
              {namespace: "dynamic", key: "quantity_unit"},
              {namespace: "dynamic", key: "quantity_multiple"},
              
                
            ]) {
            reference {
        ... on MediaImage {
          image {
            originalSrc
          }
        }
      }
            value
            key
            namespace
            
          }
      
       options{
        name
        id
        values
       }
      metafield(namespace: "custom", key: "product_title") {
        value
      }
      collections(first: 1) {
        edges {
          node {
            id
            title
          }
        }
      }
      id 
      title
      tags
      images(first: 2){
      edges{
        node{
          url
        }
      }
    }
      description
      variants(first: 100) {
        edges {
          node {
            title
            id     
            price{
            amount
          }
          }
        }
      }
    }
  }`,
  };
  const data = await fetch("/api/2022-07/graphql.json", {
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "ae71655e627d1f65b12435dd03c0ac53",
    },
    method: "POST",
    body: JSON.stringify(query),
  });
  const product_data = await data.json();
  if (product_data == {}) {
    console.log("Error occured in the Graph QL API");
  } else {
    SELECTED_PRODUCT.product_data = product_data.data.product;
    setmetaFieldsArray();
  }
}

var metaArray = [];
function setmetaFieldsArray() {
  openProductmodal();
  var array1 = [];
  var array2 = [];

  //written by bilal to replicate the functionality in single loop
  // const {metafields=[]}=SELECTED_PRODUCT.product_data;

  // const meta = [];
  // metafields.forEach((item,index,array)=>{
  //   if(index%2==0&&item){
  //   console.log(index)
  //   console.log("item",item)
  //   const ji = JSON.parse(item.value);
  //   meta.push( {
  //       title: ji[0],
  //       desc: ji[1],
  //       imgURL: `<img src='${array[index+1].reference.image.originalSrc}' />`,
  //   });
  //   }
  // });

  SELECTED_PRODUCT.product_data;

  for (i = 0; i < SELECTED_PRODUCT.product_data.metafields.length; i += 2) {
    if (
      SELECTED_PRODUCT.product_data.metafields[i] != null &&
      SELECTED_PRODUCT.product_data.metafields[i].namespace == "custom"
    ) {
      array1 = [...array1, SELECTED_PRODUCT.product_data.metafields[i]];
    }
  }
  for (i = 1; i < SELECTED_PRODUCT.product_data.metafields.length; i += 2) {
    if (
      SELECTED_PRODUCT.product_data.metafields[i] != null &&
      SELECTED_PRODUCT.product_data.metafields[i].namespace == "custom"
    ) {
      array2 = [...array2, SELECTED_PRODUCT.product_data.metafields[i]];
    }
  }
  var hell = [];
  array1.map((item, index) => {
    const ji = JSON.parse(item.value);
    const obj = {
      title: ji[0],
      desc: ji[1],
      imgURL: `<img src='${array2[index].reference.image.originalSrc}' />`,
    };
    hell.push(obj);
  });
  metaArray = [...new Set(hell)];
}

//This function is map the product Data on Modal which we get from the getProductData() function.
function productDataMapOnModal(trade_percent) {
  if (metaArray.length != 0) {
    const titles = `${
      SELECTED_PRODUCT.product_data?.metafield?.value ||
      SELECTED_PRODUCT.product_data?.title
    }`;
    document.getElementById("product_title").innerHTML = titles;
    document.getElementById("selectedOptions").innerHTML = "SELECTED OPTIONS";
    let dom = [];
    SELECTED_PRODUCT.product_data.options.map((P_options, index) => {
      // This condition runs whenever the user open the product Page modal for the first time.
      if (SELECTED_PRODUCT.options_to_update.length == 0) {
        let ind = SELECTED_PRODUCT.options_to_update.length;
        let options = "";
        let findImgforPO = metaArray.find(
          (item) => item.title === P_options.values[ind].trim()
        );
        options += `<a id='${P_options.name}' class='prod-info' value='${
          P_options.values[ind]
        }' onclick='productOptionValuesMapOnVariant_modal(${JSON.stringify(
          index
        )},${JSON.stringify(P_options.values)},${JSON.stringify(
          P_options.name
        )},${trade_percent})'>`;
        options += `<div class="atc-dr-product-variant-sub-main"><div class="atc-dr-product-variant-icon">`;
        options += `${findImgforPO.imgURL}</div>`;
        options += `<div class="atc-dr-product-variant-name-div"><p class="atc-dr-product-variant-name">${P_options.values[ind]}</p></div>`;
        options += `<div class="atc-dr-product-variant-arrow"><span><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></div>`;
        options += `</div></a>`;
        const final_product_data = `<div>${options}<div>`;
        dom.push(final_product_data);
      }
      // This condition runs when user change the by-default options-values.
      else {
        let options = "";
        let findImgforPO = metaArray.find(
          (item) => item.title === SELECTED_PRODUCT.options_to_update[index].trim()
        );
        options += `<a id='${P_options.name}' class='prod-info'   value='${
          SELECTED_PRODUCT.options_to_update[index]
        }' onclick='productOptionValuesMapOnVariant_modal(${JSON.stringify(
          index
        )},${JSON.stringify(P_options.values)},${JSON.stringify(
          P_options.name
        )},${trade_percent})' >`;
        options += `<div class="atc-dr-product-variant-sub-main"><div class="atc-dr-product-variant-icon">`;
        options += `${findImgforPO.imgURL}</div>`;
        options += `<div class="atc-dr-product-variant-name-div"><p class="atc-dr-product-variant-name">${SELECTED_PRODUCT.options_to_update[index]}</p></div>`;
        options += `<div class="atc-dr-product-variant-arrow"><span><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></div>`;
        options += `</div></a>`;
        const final_product_data = `${options}`;
        dom.push(final_product_data);
      }
    });
    document.getElementById("product_data_ins").innerHTML = dom.join("");
  } else {
    const titles = `${
      SELECTED_PRODUCT.product_data?.metafield?.value ||
      SELECTED_PRODUCT.product_data?.title
    }`;
    document.getElementById("product_title").innerHTML = titles;
    document.getElementById("selectedOptions").innerHTML = "SELECTED OPTIONS";
    let dom = [];
    SELECTED_PRODUCT.product_data.options.map((P_options, index) => {
      // This condition runs whenever the user open the product Page modal for the first time.
      if (SELECTED_PRODUCT.options_to_update.length == 0) {
        let ind = SELECTED_PRODUCT.options_to_update.length;
        let options = "";
        let findImgforPO = img_desc.find(
          (item) => item.title === P_options.values[ind].trim()
        );
        options += `<a id='${P_options.name}' class='prod-info' value='${
          P_options.values[ind]
        }' onclick='productOptionValuesMapOnVariant_modal(${JSON.stringify(
          index
        )},${JSON.stringify(P_options.values)}, ${JSON.stringify(
          P_options.name
        )},${trade_percent})'>`;
        options += `<div class="atc-dr-product-variant-sub-main"><div class="atc-dr-product-variant-icon">`;
        options += `${findImgforPO.imgURL}</div>`;
        options += `<div class="atc-dr-product-variant-name-div"><p class="atc-dr-product-variant-name">${P_options.values[ind]}</p></div>`;
        options += `<div class="atc-dr-product-variant-arrow"><span><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></div>`;
        options += `</div></a>`;
        const final_product_data = `<div>${options}<div>`;
        dom.push(final_product_data);
      }
      // This condition runs when user change the by-default options-values.
      else {
        let options = "";
        let findImgforPO = img_desc.find(
          (item) => item.title === SELECTED_PRODUCT.options_to_update[index].trim()
        );
        options += `<a id='${P_options.name}' class='prod-info'   value='${
          SELECTED_PRODUCT.options_to_update[index]
        }' onclick='productOptionValuesMapOnVariant_modal(${JSON.stringify(
          index
        )},${JSON.stringify(P_options.values)},${JSON.stringify(
          P_options.name
        )},${trade_percent})' >`;
        options += `<div class="atc-dr-product-variant-sub-main"><div class="atc-dr-product-variant-icon">`;
        options += `${findImgforPO.imgURL}</div>`;
        options += `<div class="atc-dr-product-variant-name-div"><p class="atc-dr-product-variant-name">${SELECTED_PRODUCT.options_to_update[index]}</p></div>`;
        options += `<div class="atc-dr-product-variant-arrow"><span><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></div>`;
        options += `</div></a>`;
        const final_product_data = `${options}`;
        dom.push(final_product_data);
      }
    });
    document.getElementById("product_data_ins").innerHTML = dom.join("");
  }
}

//    //This function is map the Sample product Data on Modal which we get from the getProductData() function.
function mapSampleProductDataOnModal(trade_percent) {
  const { metafields = [] } = SELECTED_PRODUCT.product_data;
  if (
    SELECTED_PRODUCT.product_data.collections.edges[0].node.id ===
    "gid://shopify/Collection/432199467326"
  ) {
    var productoptions = "";
    document.getElementById("product_title").innerHTML =
      SELECTED_PRODUCT.product_data?.metafield?.value ||
      SELECTED_PRODUCT.product_data?.title;
    const imgForProduct = `<img class='atc-dr-product-img' src='${
      SELECTED_PRODUCT.product_data.images.edges[0].node.url
    }'/>
    <div>
    ${trade_percent && DISCOUNT_TYPE=='trade_discount'?`<p class="trade-price-side-modal" >$${Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)}</p>`:""}
    <p class='atc-dr-product-price'>$${
      trade_percent
        ? Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1]/
            100 || 0  *
            SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount)).toFixed(2)
        : Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)
    }<span>${
      metafields.find((item) => item?.key === "quantity_unit")
        ? " /" + metafields.find((item) => item?.key === "quantity_unit").value
        : ""
    }</span> </p></div>`;

    document.getElementById("imgForProduct").innerHTML = imgForProduct;
    var prodQuanSelect = `<div class='atc-dr-product-qty'><select id='selectSample' class='customselect product-dr-quantity__select' onchange='handleSampleProductQuantity(${trade_percent})'>option</select></div>`;
    let options = "";
    // quantity_fanwall.map((item) => {
    dynamic_quantity_selector({ metafields }).map((item) => {
      if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length != 0) {
        if (item == SELECTED_PRODUCT.productObjToUpdate.quantity) {
          options += `<option value='${item}' selected>${item}</option>`;
        } else {
          options += `<option value='${item}'>${item}</option>`;
        }
      } else {
        options += `<option value='${item}'>${item}</option>`;
      }
    });
    productoptions = prodQuanSelect.replace(/option/g, options);
    document.getElementById("quantity_selec").innerHTML = productoptions;
    document.getElementById("product_data_ins").innerHTML = "";
    document.getElementById("selectedOptions").innerHTML = "";
    let price_tag = "";
    if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length != 0) {
      let priceToUpdate =
        SELECTED_PRODUCT.productObjToUpdate.final_line_price / 100;
      price_tag = `<p id ='final_price_data' >$${priceToUpdate.toFixed(2)}</p>`;
    } else {
      price_tag = `<p id ='final_price_data'>$${trade_percent
        ? Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1]/
            100 || 0)  *
            SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)
        : Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)}</p>`;
    }
    document.getElementById("price_per_feet").innerHTML = price_tag;
    var final_btn_appearance = "";

    if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length == 0) {
      final_btn_appearance = `<a class='atc-dr-btn' onclick='sampleProductAddingToCart(${trade_percent})'>Add to Cart</a>`;
    } else {
      final_btn_appearance = `<a class='atc-dr-btn' onclick='sampleProductUpdatingToCart(${trade_percent})'>Update Cart</a>`;
    }
    document.getElementById("btn_toggle").innerHTML = final_btn_appearance;
  } else {
    var productoptions = "";
    document.getElementById("product_title").innerHTML =
      SELECTED_PRODUCT.product_data?.metafield?.value ||
      SELECTED_PRODUCT.product_data?.title;
    const imgForProduct = `<img class='atc-dr-product-img' src='${SELECTED_PRODUCT.product_data.images.edges[0].node.url}'/><div>${trade_percent && DISCOUNT_TYPE=='trade_discount'?`<p class="trade-price-side-modal" >$${Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)}</p>`:""}<p class='atc-dr-product-price'>$${trade_percent
        ? Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1]/
            100 || 0)  *
            SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)
        : Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)}<span>${
      metafields.find((item) => item?.key === "quantity_unit")
        ? " /" + metafields.find((item) => item?.key === "quantity_unit").value
        : ""
    }</span></p></div>`;

    document.getElementById("imgForProduct").innerHTML = imgForProduct;
    var prodQuanSelect = `<div class='atc-dr-product-qty'><select id='selectSample' class='customselect product-dr-quantity__select' onchange='handleSampleProductQuantity(${trade_percent})'>option</select></div>`;
    let options = "";
    // sample_quantity.map((item) => {
    dynamic_quantity_selector({ metafields }).map((item) => {
      if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length != 0) {
        if (item == SELECTED_PRODUCT.productObjToUpdate.quantity) {
          options += `<option value='${item.quantity}' selected>${item.name}</option>`;
        } else {
          options += `<option value='${item.quantity}'>${item.name}</option>`;
        }
      } else {
        options += `<option value='${item.quantity}'>${item.name}</option>`;
      }
    });
    productoptions = prodQuanSelect.replace(/option/g, options);
    document.getElementById("quantity_selec").innerHTML = productoptions;
    document.getElementById("product_data_ins").innerHTML = "";
    document.getElementById("selectedOptions").innerHTML = "";
    let price_tag = "";
    if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length != 0) {
      let priceToUpdate =
        SELECTED_PRODUCT.productObjToUpdate.final_line_price / 100;
      price_tag = `<p id ='final_price_data' >$${priceToUpdate.toFixed(2)}</p>`;
    } else {
      price_tag = `<p id ='final_price_data'>$${trade_percent
        ? Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1]/
            100 || 0)  *
            SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)
        : Number(SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount).toFixed(2)}</p>`;
    }
    document.getElementById("price_per_feet").innerHTML = price_tag;
    var final_btn_appearance = "";

    if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length == 0) {
      final_btn_appearance = `<a class='atc-dr-btn' onclick='sampleProductAddingToCart(${trade_percent})'>Add to Cart</a>`;
    } else {
      final_btn_appearance = `<a class='atc-dr-btn' onclick='sampleProductUpdatingToCart(${trade_percent})'>Update Cart</a>`;
    }
    document.getElementById("btn_toggle").innerHTML = final_btn_appearance;
  }
  
  
}

// This function is used to handle the Sample Product Data Quantity as soon as user tries to change the Quantity from the Drop Down list.
function handleSampleProductQuantity(trade_percent) {
  let findProductPrice =
   trade_percent
        ? SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1]/
            100 || 0)  *
            SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount
        : SELECTED_PRODUCT.product_data.variants.edges[0].node.price.amount
  var sampSelec = document.getElementById("selectSample").value;
  var final_price = sampSelec * Number(findProductPrice);
  document.getElementById("final_price_data").innerText = `$${final_price.toFixed(2)}`;
}

// // This function is used to select the Quantity for the Product Data which we map on the Modal.

function QuanitySelectorForMappedProductData(valueToAdd = {}, trade_percent) {
  const { metafields } = SELECTED_PRODUCT.product_data;

  if (
    SELECTED_PRODUCT.product_data.collections.edges[0].node.id ==
      "gid://shopify/Collection/432199565630" ||
    SELECTED_PRODUCT.product_data.collections.edges[0].node.id ===
      "gid://shopify/Collection/432199532862"
  ) {
    var quantity_selector = "";
    let quantitySelect = `<div class='atc-dr-product-qty'><select id='customselect' class='customselect product-dr-quantity__select' onchange='handleQuantityChange(${trade_percent})'>cus_select</select></div>`;
    // sample_quantity.map((quantity) => {

    dynamic_quantity_selector({ metafields }).map(({ quantity, name }) => {
      if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length != 0) {
        if (quantity == SELECTED_PRODUCT.productObjToUpdate.quantity) {
          quantity_selector += `<option value='${quantity}' selected>${name}</option>`;
        } else {
          quantity_selector += `<option value='${quantity}'>${name}</option>`;
        }
      } else {
        quantity_selector += `<option value='${quantity}'>${name}</option>`;
      }
    });
    quantitySelect = quantitySelect.replace(/cus_select/g, quantity_selector);
    document.getElementById("quantity_selec").innerHTML = quantitySelect;
    reCalculatePriceInProductModal(trade_percent);
  } else {
    var quantity_selector = "";
    let quantitySelect = `<div class="atc-dr-product-cal"><a class='prod-info' onclick='mapSqFtCalculatorData()'><div class="atc-dr-product-cal-main"><div class="atc-dr-product-cal-main-icon"><svg width="23" height="31" viewBox="0 0 23 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.5594 0.783203H0.78418V30.1785H21.5594V0.783203Z" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5815 5.29883H4.76855V10.8073H17.5815V5.29883Z" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.92513 15H4.76855" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5814 15H15.4248" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.3636 15H10.207" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.92513 18.3516H4.76855" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5814 18.3516H15.4248" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.3636 18.3516H10.207" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.92513 21.7031H4.76855" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5814 21.7031H15.4248" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.3636 21.7031H10.207" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.92513 25.0566H4.76855" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17.5814 25.0566H15.4248" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.3636 25.0566H10.207" stroke="#9A9695" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></div><span class="atc-dr-product-cal-main-text">how much do I need?</span></div></a></div><div class='atc-dr-product-qty'><select id='customselect' class='customselect product-dr-quantity__select' onchange='handleQuantityChange(${trade_percent})'>cus_select</select></div>`;
    // quant_select.map((quantity) => {
    dynamic_quantity_selector({
      metafields,
    }).map((quantity) => {
      if (Object.keys(valueToAdd).length == 0) {
        if (
          quantity.quantity === SELECTED_PRODUCT.productObjToUpdate.quantity
        ) {
          quantity_selector += `<option value='${quantity.quantity}' selected>${quantity.name}</option>`;
        } else {
          quantity_selector += `<option value='${quantity.quantity}'>${quantity.name}</option>`;
        }
      } else {
        if (Object.keys(valueToAdd).length != 0) {
          if (quantity.name == valueToAdd.name) {
            quantity_selector += `<option value='${quantity.quantity}' selected>${quantity.name}</option>`;
          } else {
            quantity_selector += `<option value='${quantity.quantity}'>${quantity.name}</option>`;
          }
        } else {
          quantity_selector += `<option value='${quantity.quantity}'>${quantity.name}</option>`;
        }
      }
    });
    quantitySelect = quantitySelect.replace(/cus_select/g, quantity_selector);
    document.getElementById("quantity_selec").innerHTML = quantitySelect;
    reCalculatePriceInProductModal(trade_percent);
  }
}

// // This function is used to calculate the updated Price as soon as the quantity updated in the QuanitySelectorForMappedProductData() function.
// // This function display the updated price for the product in hand.
function reCalculatePriceInProductModal(trade_percent) {
  
  const { metafields } = SELECTED_PRODUCT.product_data;
  let dig = document.getElementsByClassName("prod-info");
  var totalPrice = "";

  for (var i = 0; i < dig.length-1; i++) {
    console.log("dig",dig[i].innerText.trim())
     if(totalPrice==""){
      totalPrice = dig[i].innerText.trim()
    }
    else{
    totalPrice = `${totalPrice} / ${dig[i].innerText.trim()}`;
      
      
    }
    
  }
  totalPrice=totalPrice.trim()
  let strforKeyPairValue =totalPrice;
console.log("Caluscasc", trade_percent,SELECTED_PRODUCT.product_data,strforKeyPairValue);
  let ProductForCart = SELECTED_PRODUCT.product_data.variants.edges.find(
    (item, index) => item.node.title == strforKeyPairValue
  );
  console.log("ProductForCart",ProductForCart)
  if (
    SELECTED_PRODUCT.product_data.collections.edges[0].node.id ==
    "gid://shopify/Collection/432199172414"
  ) {
    const imgForProduct = `<img class='atc-dr-product-img' src='${
      SELECTED_PRODUCT.product_data.images.edges[0].node.url
    }'/><div>${trade_percent?`<p class="trade-price-side-modal" >$${Number(ProductForCart.node.price.amount).toFixed(2)}</p>`:""}<p class='atc-dr-product-price'>$${
      trade_percent
        ? Number(ProductForCart.node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1] /
            100) *
            ProductForCart.node.price.amount).toFixed(2)
        : Number(ProductForCart.node.price.amount).toFixed(2)
    } <span>${
      metafields.find((item) => item?.key === "quantity_unit")
        ? " /" + metafields.find((item) => item?.key === "quantity_unit").value
        : ""
    }</span></p></div>`;
    document.getElementById("imgForProduct").innerHTML = imgForProduct;
  } else {
    const imgForProduct = `<img class='atc-dr-product-img' src='${
      SELECTED_PRODUCT.product_data.images.edges[0].node.url
    }'/><div>${trade_percent?`<p class="trade-price-side-modal" >$${Number(ProductForCart.node.price.amount).toFixed(2)}</p>`:""}<p class='atc-dr-product-price'>$${
      trade_percent
        ? Number(ProductForCart.node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1] /
            100) *
            ProductForCart.node.price.amount).toFixed(2)
        : Number(ProductForCart.node.price.amount).toFixed(2)
    }<span>${
      metafields.find((item) => item?.key === "quantity_unit")
        ? " /" + metafields.find((item) => item?.key === "quantity_unit").value
        : ""
    }</span></p></div>`;
    document.getElementById("imgForProduct").innerHTML = imgForProduct;
  }
  var quantity = document.getElementById("customselect").value;
  var finalPrice =
    Number(quantity) *
    (trade_percent
      ? ProductForCart.node.price.amount -
        (SELECTED_PRODUCT.product_data.tags
          .find((a) => a.includes(DISCOUNT_TYPE))
          ?.split(":")[1] /
          100) *
          ProductForCart.node.price.amount
      : ProductForCart.node.price.amount);
  console.log(
    "final PRice",
    typeof quantity,
    finalPrice,
    trade_percent
      ? ProductForCart.node.price.amount -
          (SELECTED_PRODUCT.product_data.tags
            .find((a) => a.includes(DISCOUNT_TYPE))
            ?.split(":")[1] /
            100) *
            ProductForCart.node.price.amount
      : ProductForCart.node.price.amount
  );
  let price_tag = `<p id ='final_price_data' value='$${finalPrice}'>$${finalPrice.toFixed(2)}</p>`;
  document.getElementById("price_per_feet").innerHTML = price_tag;
  var final_btn_appearance = "";
  if (Object.keys(SELECTED_PRODUCT.productObjToUpdate).length == 0) {
    final_btn_appearance = `<a class='atc-dr-btn' onclick='addToCart(${trade_percent})'>Add to Cart</a>`;
  } else {
    final_btn_appearance = `<a class='atc-dr-btn' onclick='updateToCart(${trade_percent})'>Update Cart</a>`;
  }
  document.getElementById("btn_toggle").innerHTML = final_btn_appearance;
}

// This function helps user to change the Variant/Options-values of the Product. It opens a new Modal in which all the values are displayed for the
// specific product option through which user can select his own choice
function productOptionValuesMapOnVariant_modal(index, value, name,trade_percent) {
  console.log("DAdsaasd", value, metaArray);
  if (metaArray.length != 0) {
    openVariantModal();
    let prodOptions = document.getElementsByClassName("prod-info");
    var byDefaultProdOpt = [];
    for (var i = 0; i < prodOptions.length; i++) {
      byDefaultProdOpt = [...byDefaultProdOpt, prodOptions[i].innerText];
    }
    let DOM = [];
    const title = `CHOOSE YOUR ${name}`;
    document.getElementById("variant_option_title").innerHTML = title;
    value.map((options) => {
      let prodOpt = "";
      let findImgforPO = metaArray.find((item) => item.title === options);
   
      if (byDefaultProdOpt[index].trim() == findImgforPO.title) {
        prodOpt += `<a  id='${options}' value='${options}' onclick='finalizeProductOptiontoMapOnModal(${JSON.stringify(
          options
        )}, ${JSON.stringify(byDefaultProdOpt)}, ${JSON.stringify(index)},${trade_percent})'>`;
        prodOpt += `<div class='variant-option-main selected'><div class='variant-option-icon'>`;
        prodOpt += `${findImgforPO.imgURL}</div><div class="variant-option-text-main">`;

        prodOpt += `<p class='variant-option-text-main1'>${options}</p>`;
        prodOpt += `<p class='variant-option-text-main2'>${findImgforPO.desc}</p>`;
        prodOpt += `</div></div></a>`;
        const final_product_data = `${prodOpt}`;
        DOM.push(final_product_data);
      } else {
        prodOpt += `<a id='${options}' value='${options}' onclick='finalizeProductOptiontoMapOnModal(${JSON.stringify(
          options
        )}, ${JSON.stringify(byDefaultProdOpt)}, ${JSON.stringify(index)},${trade_percent})'>`;
        prodOpt += `<div class='variant-option-main'><div class='variant-option-icon'>`;

        prodOpt += `${findImgforPO.imgURL}</div><div class="variant-option-text-main">`;
        prodOpt += `<p class='variant-option-text-main1'>${options}</p>`;
        prodOpt += `<p class='variant-option-text-main2'>${findImgforPO.desc}</p>`;
        prodOpt += `</div></div></a>`;
        const final_product_data = `${prodOpt}`;
        DOM.push(final_product_data);
      }
    });
    document.getElementById("variant_modal_data").innerHTML = DOM.join("");
  } else {
    openVariantModal();
    let prodOptions = document.getElementsByClassName("prod-info");
    var byDefaultProdOpt = [];
    for (var i = 0; i < prodOptions.length; i++) {
      byDefaultProdOpt = [...byDefaultProdOpt, prodOptions[i].innerText];
    }
    let DOM = [];
    const title = `CHOOSE YOUR ${name}`;

    document.getElementById("variant_option_title").innerHTML = title;
    value.map((options) => {
      let prodOpt = "";
      let findImgforPO = img_desc.find((item) => item.title === options.trim());
      if (byDefaultProdOpt[index] == findImgforPO.title) {
        prodOpt += `<a  id='${options}' value='${options}' onclick='finalizeProductOptiontoMapOnModal(${JSON.stringify(
          options
        )}, ${JSON.stringify(byDefaultProdOpt)}, ${JSON.stringify(index)},${trade_percent})'>`;
        prodOpt += `<div class='variant-option-main selected'><div class='variant-option-icon'>`;
        prodOpt += `${findImgforPO.imgURL}</div><div class="variant-option-text-main">`;

        prodOpt += `<p class='variant-option-text-main1'>${options}</p>`;
        prodOpt += `<p class='variant-option-text-main2'>${findImgforPO.desc}</p>`;
        prodOpt += `</div></div></a>`;
        const final_product_data = `${prodOpt}`;
        DOM.push(final_product_data);
      } else {
        prodOpt += `<a id='${options}' value='${options}' onclick='finalizeProductOptiontoMapOnModal(${JSON.stringify(
          options
        )}, ${JSON.stringify(byDefaultProdOpt)}, ${JSON.stringify(index)},${trade_percent})'>`;
        prodOpt += `<div class='variant-option-main'><div class='variant-option-icon'>`;

        prodOpt += `${findImgforPO.imgURL}</div><div class="variant-option-text-main">`;
        prodOpt += `<p class='variant-option-text-main1'>${options}</p>`;
        prodOpt += `<p class='variant-option-text-main2'>${findImgforPO.desc}</p>`;
        prodOpt += `</div></div></a>`;
        const final_product_data = `${prodOpt}`;
        DOM.push(final_product_data);
      }
    });
    document.getElementById("variant_modal_data").innerHTML = DOM.join("");
  }
}

function finalizeProductOptiontoMapOnModal(options, updatedArray, index,trade_percent) {
  closeVariantModal();
  updatedArray[index] = options;
  SELECTED_PRODUCT.options_to_update = updatedArray;
  productDataMapOnModal(trade_percent);
  reCalculatePriceInProductModal(trade_percent);
}

// // This function is used to Handle the Price and the Quantity as soon as the user tries to change the Square Feet Value from dropdown List in the Modal
function handleQuantityChange(trade_percent) {
  console.log("handleQuantity", trade_percent);
  var optionSelectedArray = [];
  var byDefaultSelectedValue = document.getElementsByClassName("prod-info");

  for (var i = 0; i < byDefaultSelectedValue.length; i++) {
    optionSelectedArray = [
      ...optionSelectedArray,
      byDefaultSelectedValue[i].innerText,
    ];
  }

// const strforKeyPairValue = `${optionSelectedArray[0]} / ${optionSelectedArray[1]} / ${optionSelectedArray[2]}`;
optionSelectedArray.pop();  
  const strforKeyPairValue = optionSelectedArray.map(o=>o.trim()).join(" / ");
  console.log("strforKeyPairValue",strforKeyPairValue)
  const ProductForCart = SELECTED_PRODUCT.product_data.variants.edges.find(
    (item, index) => item.node.title === strforKeyPairValue
  );

  var quantity = document.getElementById("customselect").value;
  var product_price = trade_percent
    ? Number(ProductForCart.node.price.amount) -
      (SELECTED_PRODUCT.product_data.tags
        .find((a) => a.includes(DISCOUNT_TYPE))
        ?.split(":")[1] /
        100) *
        Number(ProductForCart.node.price.amount)
    : Number(ProductForCart.node.price.amount);
  var total_product_price = product_price * quantity;
  var final_value = `$${total_product_price.toFixed(2)}`;

  document.getElementById("final_price_data").innerHTML = final_value;
  document.getElementById("final_price_data").value = final_value;
}

// This function is used to predict the SqFt for the Product.
// When user Clicks on the "How much Do i need?" Button The Variant_Modal will appear.
function mapSqFtCalculatorData() {
  openVariantModal();
  let weight_heightOption = "";

  let title = `CALCULATE YOUR SQUARE FOOTATGE`;
  document.getElementById("variant_option_title").innerHTML = title;

  weight_heightOption += `<div class='atc-dr-calculate-row'><span class='atc-dr-calculate-row-text'>Wall Height, in Inches = </span>`;
  weight_heightOption += `<input class='get_value atc-dr-calculate-row-input' onkeyup='sqFtCalculatorForProductQuantity()' type='number'></input></div>`;

  weight_heightOption += `<div class='atc-dr-calculate-row'><span class='atc-dr-calculate-row-text'>Wall Width, in Inches = </span>`;
  weight_heightOption += `<input class='get_value atc-dr-calculate-row-input' onkeyup='sqFtCalculatorForProductQuantity()' type='number'></input> </div>`;

  weight_heightOption += `<div class='atc-dr-calculate-row'><span class='atc-dr-calculate-row-text'>Area of Wall (in Square Feet) = </span>`;
  weight_heightOption += `<input class='calculated_value atc-dr-calculate-row-input' id = 'calculated_value' value='0' disabled></input> </div>`;

  weight_heightOption += `<div class='atc-dr-calculate-row'><span class='atc-dr-calculate-row-text'>We Recommend You Order = </span>`;
  weight_heightOption += `<a class='recommended_value atc-dr-calculate-row-btn' id= 'recommended_value'  value='-- SQUARE FEET' onclick='calculatedValuetoAdd()'><span>--</span><span>SQUARE FEET</span></a></div>`;

  weight_heightOption += `<div class='calculatorDrawer__video-container'><video class="videoSection__video" src="https://cdn.shopify.com/videos/c/o/v/81b19e2c754d427fbfa898c7fcab4c0d.mp4" type="" preload="auto" playsinline="" controls="" poster="https://cdn.shopify.com/s/files/1/0701/0254/8798/files/measure_poster.webp?v=1675795764"></video></div>`;

  const final_product_data = `${weight_heightOption}`;
  document.getElementById("variant_modal_data").innerHTML = final_product_data;
}

// As soon as the modal appears this functions runs and it takes the input from user in the inches for Widht and height.
// Then, it converts the Inches or Width and Height into the Square-Feet Value and it suggest user to choose the best SquareFeet Quantity for him.

function sqFtCalculatorForProductQuantity() {
  var get_values = document.getElementsByClassName("get_value");
  let values_array = [];
  for (var i = 0; i < get_values.length; i++) {
    const calculatedValue = get_values[i].value / 12;
    values_array = [...values_array, calculatedValue];
  }
  const sqFtCal = values_array[0] * values_array[1] ;
  // if (sqFtCal != 0) {
  //   let finalNumber = sqFtCal.toFixed(1);
  //   document.getElementById("calculated_value").value = finalNumber;
  //   const final_value = quant_select.find((item) => item.quantity > sqFtCal);
  //   let valueToAdd = `${final_value.quantity} SQUARE FEET`;
  //   document.getElementById("recommended_value").innerHTML = valueToAdd;
  //   document.getElementById("recommended_value").value = final_value.name;
  // }
  if (sqFtCal != 0) {
    let finalNumber = sqFtCal.toFixed(1) ;
    document.getElementById("calculated_value").value = finalNumber;
    //adding 5% in total square feet before rounding it to nearest 10
    let value_to_add_in_recommended = finalNumber * 1.05;
    //rounding final_value to nearest 10
    const final_value = Math.ceil(value_to_add_in_recommended / 10) * 10;
    let valueToAdd = `${final_value} SQUARE FEET`;
    document.getElementById("recommended_value").innerHTML = valueToAdd;
    document.getElementById("recommended_value").value = final_value.name;
  }
}

// As soon as the user clicks on the seggested Calculated Value button in the "How much do i need?" Section this function will run and update
// the quantity and the price in the main product Modal Page.
function calculatedValuetoAdd() {
  closeVariantModal();
  let valueToAdd = document.getElementById("recommended_value").innerHTML.split("SQUARE")[0].trim();
  let findValuetoAdd = quant_select.find((item) => item.quantity == valueToAdd);
  QuanitySelectorForMappedProductData(findValuetoAdd);
}

// This function is used to Add the Sample Product data into the Cart.
function sampleProductAddingToCart(trade_percent) {
  let gid = SELECTED_PRODUCT.product_data.variants.edges[0].node.id;
  var quantity = document.getElementById("selectSample").value;
  var id = gid.split("/");

  //new code written by bilal
  const items = JSON.stringify({
    quantity: Number(quantity),
    id: id[4],
    properties: {
      meta: SELECTED_PRODUCT.product_data.metafields,
      discount_percent:trade_percent?SELECTED_PRODUCT.product_data.tags.find(a=>a.includes(DISCOUNT_TYPE))?SELECTED_PRODUCT.product_data.tags.find(a=>a.includes(DISCOUNT_TYPE)).split(":")[1]:0:0
    },
  });
  // var myHeaders = new Headers();
  // var formdata = new FormData();
  // formdata.append("quantity", `${quantity}`);
  // formdata.append("form_type", "product");
  // formdata.append("id", id[4]);
  var requestOptions = {
    method: "POST",
    body: items,
    headers: {
      "content-type": "application/json",
    },
    redirect: "follow",
  };
  fetch("/cart/add.js", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      custom_cart_data();
      closeProductmodal();
      SELECTED_PRODUCT.options_to_update = [];
      SELECTED_PRODUCT.productObjToUpdate = {};
      SELECTED_PRODUCT.product_data = {};
    })
    .catch((error) => console.log("error", error));
}

function addToCart(trade_percent) {
  var optionSelectedArray = [];
  var byDefaultSelectedValue = document.getElementsByClassName("prod-info");
  for (var i = 0; i < byDefaultSelectedValue.length; i++) {
    optionSelectedArray = [
      ...optionSelectedArray,
      byDefaultSelectedValue[i].innerText,
    ];
  }
  // const strforKeyPairValue = `${optionSelectedArray[0]} / ${optionSelectedArray[1]} / ${optionSelectedArray[2]}`;
   // const strforKeyPairValue = `${optionSelectedArray[0].trim()} / ${optionSelectedArray[1].trim()} / ${optionSelectedArray[2].trim()}`;
    optionSelectedArray.pop();  
  const strforKeyPairValue = optionSelectedArray.map(o=>o.trim()).join(" / ");
   console.log("strforKeyPairValue",strforKeyPairValue)
  const ProductForCart = SELECTED_PRODUCT.product_data.variants.edges.find(
    (item, index) => item.node.title === strforKeyPairValue
  );
  var data = document.getElementById("customselect").value;
  const ProductIdForCart = ProductForCart.node.id.split("/");

  //new code written by bilal
  const items = JSON.stringify({
    "Width Options": optionSelectedArray[0],
    "Length Options": optionSelectedArray[1],
    "Treatment Options": optionSelectedArray[2],
    quantity: Number(data),
    // form_type: "product",
    id: ProductIdForCart[4],
    properties: {
      meta: SELECTED_PRODUCT.product_data.metafields,
      discount_percent:trade_percent?SELECTED_PRODUCT.product_data.tags.find(a=>a.includes(DISCOUNT_TYPE))?.split(":")[1]:0
      
    },
  });

  //old code
  // var formdata = new FormData();

  // formdata.append("Width Options", optionSelectedArray[0]);
  // formdata.append("Length Options", optionSelectedArray[1]);
  // formdata.append("Treatment Options", optionSelectedArray[2]);
  // formdata.append("quantity", `${data}`);
  // formdata.append("form_type", "product");
  // formdata.append("id", ProductIdForCart[4]);
  // formdata.append("properties", {
  // 	properties: SELECTED_PRODUCT.product_data.metafields,
  // });
  // console.log(formdata);
  var requestOptions = {
    method: "POST",
    body: items,
    headers: {
      "content-type": "application/json",
    },
    redirect: "follow",
  };
  fetch("/cart/add.js", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      custom_cart_data();
      closeProductmodal();
      SELECTED_PRODUCT.options_to_update = [];
      SELECTED_PRODUCT.productObjToUpdate = {};
      SELECTED_PRODUCT.product_data = {};
    })
    .catch((error) => console.log("error", error));
}
function updateToCart(trade_percent) {
  var optionSelectedArray = [];
  var byDefaultSelectedValue = document.getElementsByClassName("prod-info");
  for (var i = 0; i < byDefaultSelectedValue.length; i++) {
    optionSelectedArray = [
      ...optionSelectedArray,
      byDefaultSelectedValue[i].innerText,
    ];
  }
  // const strforKeyPairValue = `${optionSelectedArray[0]} / ${optionSelectedArray[1]} / ${optionSelectedArray[2]}`;
    // const strforKeyPairValue = `${optionSelectedArray[0].trim()} / ${optionSelectedArray[1].trim()} / ${optionSelectedArray[2].trim()}`;
    optionSelectedArray.pop();  
  
  const strforKeyPairValue = optionSelectedArray.map(o=>o.trim()).join(" / ");
   console.log("strforKeyPairValue",strforKeyPairValue,optionSelectedArray)
  const ProductForCart = SELECTED_PRODUCT.product_data.variants.edges.find(
    (item, index) => item.node.title === strforKeyPairValue
  );
  var data = document.getElementById("customselect").value;
  const ProductIdForCart = ProductForCart.node.id.split("/");

  
  var myHeaders = new Headers();
  var formdata = new FormData();
  formdata.append("quantity", 0);
  formdata.append("id", SELECTED_PRODUCT.productObjToUpdate.variant_id);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };
  var myHeader = new Headers();
  
  // var formdatas = new FormData();
  // formdatas.append("Width Options", optionSelectedArray[0]);
  // formdatas.append("Length Options", optionSelectedArray[1]);
  // formdatas.append("Treatment Options", optionSelectedArray[2]);
  // formdatas.append("quantity", data);
  // formdatas.append("form_type", "product");
  // formdatas.append("id", ProductIdForCart[4]);
  // formdata.append("properties", {
  // 	metafields:SELECTED_PRODUCT.product_data.metafields,discount_percent:trade_percent
  // });

  const items = JSON.stringify({
    "Width Options": optionSelectedArray[0],
    "Length Options": optionSelectedArray[1],
    "Treatment Options": optionSelectedArray[2],
    quantity: Number(data),
    // form_type: "product",
    id: ProductIdForCart[4],
    properties: {
      meta: SELECTED_PRODUCT.product_data.metafields,
      discount_percent:trade_percent?SELECTED_PRODUCT.product_data.tags.find(a=>a.includes(DISCOUNT_TYPE))?.split(":")[1]:0
      
    },
  });
  var requestOption = {
    method: "POST",
     body: items,
    headers: {
      "content-type": "application/json",
    },
    redirect: "follow",
  };
  fetch("/cart/change.js", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      fetch("/cart/add.js", requestOption)
        .then((response) => response.json())
        .then((result) => {
          custom_cart_data();
          closeProductmodal();
          SELECTED_PRODUCT.options_to_update = [];
          SELECTED_PRODUCT.productObjToUpdate = {};
          SELECTED_PRODUCT.product_data = {};
          SELECTED_PRODUCT.cart_product_data = {};
        })
        .catch((error) => console.log("error", error));
    })
    .catch((error) => console.log("error", error));
}

function custom_cart_data() {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  fetch("/cart.js", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      metadata(result);
      // Define a new function to run after the for loop has completed
    })
    .catch((error) => console.log("error", error));
}

var metaCartArray = [];
var titleFromMetaField = [];

async function metadata(result) {
  const arr = [];
  for (let i = 0; i < result.items.length; i++) {
    const gid = `gid://shopify/Product/${result.items[i].product_id}`;
    arr.push(gid);
  }

  const arrString = JSON.stringify(arr);

  const query = {
    query: `{
    nodes(ids: ${arrString}) {
     ...on Product{
       metafields(identifiers: [
          {namespace: "custom", key: "option_1_name_and_desc"},
          {namespace: "custom", key: "option_1_image"},
          {namespace: "custom", key: "option_2_name_and_desc"},
          {namespace: "custom", key: "option_2_image"},
          {namespace: "custom", key: "option_3_name_and_desc"},
          {namespace: "custom", key: "option_3_image"},
          {namespace: "custom", key: "option_4_name_and_desc"},
          {namespace: "custom", key: "option_4_image"},
          {namespace: "custom", key: "option_5_name_and_desc"},
          {namespace: "custom", key: "option_5_image"},
          {namespace: "custom", key: "option_6_name_and_desc"},
          {namespace: "custom", key: "option_6_image"},
          {namespace: "custom", key: "option_7_name_and_desc"},
            {namespace: "custom", key: "option_7_image"},
            {namespace: "custom", key: "option_8_name_and_desc"},
            {namespace: "custom", key: "option_8_image"},
            {namespace: "custom", key: "option_9_name_and_desc"},
            {namespace: "custom", key: "option_9_image"},
            {namespace: "custom", key: "option_10_name_and_desc"},
            {namespace: "custom", key: "option_10_image"},
        
        ]) {
          reference {
            ... on MediaImage {
              image {
                originalSrc
              }
            }
          }
          value
        }
        metafield(namespace: "custom", key: "product_title") {
          value
        }
        id
     }
        
      }
  }`,
  };

  const data = await fetch("/api/2022-07/graphql.json", {
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "ae71655e627d1f65b12435dd03c0ac53",
    },
    method: "POST",
    body: JSON.stringify(query),
  });

  const product_data = await data.json();

  for (let k = 0; k < product_data.data.nodes.length; k++) {
    const array1 = [];
    const array2 = [];

    if (product_data.data.nodes[k].metafields[0] != null) {
      for (
        let j = 0;
        j < product_data.data.nodes[k].metafields.length;
        j += 2
      ) {
        if (product_data.data.nodes[k].metafields[j] != null) {
          array1.push(product_data.data.nodes[k].metafields[j]);
        }
      }

      for (
        let i = 1;
        i < product_data.data.nodes[k].metafields.length;
        i += 2
      ) {
        if (product_data.data.nodes[k].metafields[0] != null) {
          array2.push(product_data.data.nodes[k].metafields[i]);
        }
      }

      const hell = [];

      array1.map((item, index) => {
        const ji = JSON.parse(item.value);
        const obj = {
          title: ji[0],
          desc: ji[1],
          imgURL: `<img src='${array2[index].reference.image.originalSrc}' />`,
        };
        hell.push(obj);
      });

      metaArray.push(...hell);

      let id = {
        ID: product_data.data.nodes[k].id.split("/")[4],
      };
      metaCartArray.push(id);
    }
  }

  metaArray = [...new Set(metaArray)];

  titleFromMetaField = [...product_data.data.nodes];
  openCustomCart();
  mapAllProductsDataOnCustomCart(result);
}

function metaFieldsProcessing(product_data) {}

function custom_cart() {
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  fetch("/cart.js", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      mapAllProductsDataOnCustomCart(result);
    })
    .catch((error) => console.log("error", error));
}
custom_cart();

// // This function is used to Map the Whole Cart Data as per the Product type. For(e:g): Main Product and Sample Product.
async function mapAllProductsDataOnCustomCart(cartData) {
  if (cartData.items.length > 0) {
    SELECTED_PRODUCT.options_to_update = [];
    SELECTED_PRODUCT.productObjToUpdate = {};
    SELECTED_PRODUCT.product_data = {};
    SELECTED_PRODUCT.cart_product_data = {};

    var itemCount = `${cartData?.items?.length}`;
    document.getElementById("cus-cart").innerHTML = itemCount;
    document.getElementById("itemCount").innerHTML = itemCount;
    var productImage = "";
    const productName = "<h2 class='title'>name</h2>";
    const productImg = "<img class='img'src='imageURL'></img>";
    const proOptVal = "optVal";
    let localNames = productName;
    let localImages = productImg;
    let DOM = [];
    document.getElementById("emptyCart").innerHTML = "";
    cartData.items.map((ProdInCart) => {
      console.log("ProdInCart",ProdInCart)
      let { meta: metafields = [], discount_percent } = ProdInCart.properties;
      
      if(!Array.isArray(metafields)){
    metafields= Object.keys(metafields).map(key=>metafields[key])
  }
      // This condition displays all the Products Data on Cart
      const findTitle = titleFromMetaField.find(
        (item) => item.id.split("/")[4] == ProdInCart.product_id
      );

      if (ProdInCart.options_with_values[0].value != "Default Title") {
        const findId = metaCartArray.find(
          (item) => item.ID == ProdInCart.product_id
        );

        if (findId != undefined) {
          if (ProdInCart.product_type == "stikit") {
            var quantity_selector = "";
            let quantitySelect = `<div class='whole-selector'><select id='${
              ProdInCart.id
            }' class='product-quantity' name='quantity' onchange='quantitySelectorFromCart(${JSON.stringify(
              ProdInCart.id
            )})' >cus_select</select><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`;

            dynamic_quantity_selector({ metafields }).map(
              ({ quantity, name }) => {
                // sample_quantity.map(({ quantity, name }) => {
                if (quantity === ProdInCart.quantity) {
                  quantity_selector += `<option value='${quantity}' selected>${name}</option>`;
                } else {
                  quantity_selector += `<option value='${quantity}'>${name}</option>`;
                }
              }
            );
            quantitySelect = quantitySelect.replace(
              /cus_select/g,
              quantity_selector
            );
            productImage = localImages.replace(
              /imageURL/g,
              ProdInCart.featured_image.url
            );
            productOptions = localNames.replace(
              /name/g,
              findTitle?.metafield?.value || ProdInCart.product_title
            );
            var tag_price =  ProdInCart.original_line_price / 100;            
            let original_price = ProdInCart.original_price / 100;
            tag_price = tag_price - discount_percent * tag_price /100
            original_price = original_price - discount_percent *original_price/100
            let price_tag = `<span class='small-price-per-sqft' disabled>$${original_price.toFixed(2)}${
              metafields.find((item) => item?.key === "quantity_unit")
                ? "/" +
                  metafields.find((item) => item?.key === "quantity_unit").value
                : ""
            }</span>`;
            let finalProductPrice = `<p class='text'>$${tag_price.toFixed(
              2
            )}</p>`;

            let localProOptVal = proOptVal;
            let options = "";
            ProdInCart.options_with_values.map((PO_values) => {
              let findImgforPO = metaArray.find(
                (item) => item.title === PO_values.value
              );
              options += `<div class='variant-cta-logo'>${findImgforPO.imgURL}</div>`;
            });
            localProOptVal = localProOptVal.replace(/optVal/g, options);
            let productToUpdate = {
              quantity: ProdInCart.quantity,
              variant_id: ProdInCart.variant_id,
            };
            let btnForEditProduct = `<button class='options-cta' onclick='setupProductModal(${
              ProdInCart.product_id
            }, ${JSON.stringify(productToUpdate)},${JSON.stringify(
              ProdInCart.variant_options
            )},${discount_percent},"${DISCOUNT_TYPE}")'>edit options</button>`;
            const final_Cart_Data = `<div class="product-cart-card"><div class="for-whole-prod"><button class="remove-item-cta" onclick='deleteProduct(${JSON.stringify(
              ProdInCart.id
            )})'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.14258 10.1426C1.14258 15.1131 5.17201 19.1426 10.1426 19.1426C15.1131 19.1426 19.1426 15.1131 19.1426 10.1426C19.1426 5.17202 15.1131 1.14258 10.1426 1.14258C5.17201 1.14258 1.14258 5.17202 1.14258 10.1426Z" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 6.28516L10.0143 10.2709L6.02857 6.28516" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.02857 14.2572L10.0143 10.2715L14 14.2572" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></button><div class="whole-content"><div class="whole-image"><div class="product-cart-card-img">${productImage}</div></div><div class="whole-product-infro">${productOptions}${price_tag}<div class="variant-cta"><div class="variants-with-log">${localProOptVal}</div><div class="edit-variants">${btnForEditProduct}</div></div></div></div><div class="whole-quantity-and-price">${quantitySelect}<div class="whole-price">${finalProductPrice}</div></div></div></div>`;
            DOM.push(final_Cart_Data);
          } else {
            var quantity_selector = "";
            let quantitySelect = `<div class='whole-selector'><select id='${
              ProdInCart.id
            }' class='product-quantity' name='quantity' onchange='quantitySelectorFromCart(${JSON.stringify(
              ProdInCart.id
            )})' >cus_select</select><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`;
            // quant_select.map((quantity) => {
            dynamic_quantity_selector({
              metafields,
            }).map((quantity) => {
              if (quantity.quantity === ProdInCart.quantity) {
                quantity_selector += `<option value='${quantity.quantity}' selected>${quantity.name}</option>`;
              } else {
                quantity_selector += `<option value='${quantity.quantity}'>${quantity.name}</option>`;
              }
            });
            quantitySelect = quantitySelect.replace(
              /cus_select/g,
              quantity_selector
            );
            productImage = localImages.replace(
              /imageURL/g,
              ProdInCart.featured_image.url
            );
            productOptions = localNames.replace(
              /name/g,
              findTitle?.metafield?.value || ProdInCart.product_title
            );
            var tag_price = ProdInCart.original_line_price / 100;
            let original_price = ProdInCart.original_price / 100;
            tag_price = tag_price - discount_percent * tag_price /100
            original_price = original_price - discount_percent *original_price/100
            let price_tag = `<span class='small-price-per-sqft' disabled>$${original_price.toFixed(2)}${
              metafields.find((item) => item?.key === "quantity_unit")
                ? "/" +
                  metafields.find((item) => item?.key === "quantity_unit").value
                : ""
            }</span>`;
            let finalProductPrice = `<p class='text'>$${tag_price.toFixed(
              2
            )}</p>`;

            let localProOptVal = proOptVal;
            let options = "";
            ProdInCart.options_with_values.map((PO_values) => {
              let findImgforPO = metaArray.find(
                (item) => item.title === PO_values.value
              );
              options += `<div class='variant-cta-logo'>${findImgforPO.imgURL}</div>`;
            });
            localProOptVal = localProOptVal.replace(/optVal/g, options);
            let productToUpdate = {
              quantity: ProdInCart.quantity,
              variant_id: ProdInCart.variant_id,
            };
            let btnForEditProduct = `<button class='options-cta' onclick='setupProductModal(${
              ProdInCart.product_id
            }, ${JSON.stringify(productToUpdate)},${JSON.stringify(
              ProdInCart.variant_options
            )},${discount_percent},"${DISCOUNT_TYPE}")'>edit options</button>`;
            const final_Cart_Data = `<div class="product-cart-card"><div class="for-whole-prod"><button class="remove-item-cta" onclick='deleteProduct(${JSON.stringify(
              ProdInCart.id
            )})'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.14258 10.1426C1.14258 15.1131 5.17201 19.1426 10.1426 19.1426C15.1131 19.1426 19.1426 15.1131 19.1426 10.1426C19.1426 5.17202 15.1131 1.14258 10.1426 1.14258C5.17201 1.14258 1.14258 5.17202 1.14258 10.1426Z" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 6.28516L10.0143 10.2709L6.02857 6.28516" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.02857 14.2572L10.0143 10.2715L14 14.2572" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></button><div class="whole-content"><div class="whole-image"><div class="product-cart-card-img">${productImage}</div></div><div class="whole-product-infro">${productOptions}${price_tag}<div class="variant-cta"><div class="variants-with-log">${localProOptVal}</div><div class="edit-variants">${btnForEditProduct}</div></div></div></div><div class="whole-quantity-and-price">${quantitySelect}<div class="whole-price">${finalProductPrice}</div></div></div></div>`;
            DOM.push(final_Cart_Data);
          }
        } else {
          if (ProdInCart.product_type == "stikit") {
            var quantity_selector = "";
            let quantitySelect = `<div class='whole-selector'><select id='${
              ProdInCart.id
            }' class='product-quantity' name='quantity' onchange='quantitySelectorFromCart(${JSON.stringify(
              ProdInCart.id
            )})' >cus_select</select><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`;
            dynamic_quantity_selector({
              metafields,
            }).map(({ quantity, name }) => {
              if (quantity === ProdInCart.quantity) {
                quantity_selector += `<option value='${quantity}' selected>${name}</option>`;
              } else {
                quantity_selector += `<option value='${quantity}'>${name}</option>`;
              }
            });
            quantitySelect = quantitySelect.replace(
              /cus_select/g,
              quantity_selector
            );
            productImage = localImages.replace(
              /imageURL/g,
              ProdInCart.featured_image.url
            );
            productOptions = localNames.replace(
              /name/g,
              findTitle?.metafield?.value || ProdInCart.product_title
            );
            var tag_price = ProdInCart.original_line_price / 100;
            let original_price = ProdInCart.original_price / 100;
            tag_price = tag_price - discount_percent * tag_price /100
            original_price = original_price - discount_percent *original_price/100
            let price_tag = `<span class='small-price-per-sqft' disabled>$${original_price.toFixed(2)}${
              metafields.find((item) => item?.key === "quantity_unit")
                ? "/" +
                  metafields.find((item) => item?.key === "quantity_unit").value
                : ""
            }</span>`;
            let finalProductPrice = `<p class='text'>$${tag_price.toFixed(
              2
            )}</p>`;

            let localProOptVal = proOptVal;
            let options = "";
            ProdInCart.options_with_values.map((PO_values) => {
              let findImgforPO = img_desc.find(
                (item) => item.title === PO_values.value
              );
              options += `<div class='variant-cta-logo'>${findImgforPO.imgURL}</div>`;
            });
            localProOptVal = localProOptVal.replace(/optVal/g, options);
            let productToUpdate = {
              quantity: ProdInCart.quantity,
              variant_id: ProdInCart.variant_id,
            };
            let btnForEditProduct = `<button class='options-cta' onclick='setupProductModal(${
              ProdInCart.product_id
            }, ${JSON.stringify(productToUpdate)},${JSON.stringify(
              ProdInCart.variant_options
            )},${discount_percent},"${DISCOUNT_TYPE}")'>edit options</button>`;
            const final_Cart_Data = `<div class="product-cart-card"><div class="for-whole-prod"><button class="remove-item-cta" onclick='deleteProduct(${JSON.stringify(
              ProdInCart.id
            )})'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.14258 10.1426C1.14258 15.1131 5.17201 19.1426 10.1426 19.1426C15.1131 19.1426 19.1426 15.1131 19.1426 10.1426C19.1426 5.17202 15.1131 1.14258 10.1426 1.14258C5.17201 1.14258 1.14258 5.17202 1.14258 10.1426Z" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 6.28516L10.0143 10.2709L6.02857 6.28516" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.02857 14.2572L10.0143 10.2715L14 14.2572" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></button><div class="whole-content"><div class="whole-image"><div class="product-cart-card-img">${productImage}</div></div><div class="whole-product-infro">${productOptions}${price_tag}<div class="variant-cta"><div class="variants-with-log">${localProOptVal}</div><div class="edit-variants">${btnForEditProduct}</div></div></div></div><div class="whole-quantity-and-price">${quantitySelect}<div class="whole-price">${finalProductPrice}</div></div></div></div>`;
            DOM.push(final_Cart_Data);
          } else {
            var quantity_selector = "";
            let quantitySelect = `<div class='whole-selector'><select id='${
              ProdInCart.id
            }' class='product-quantity' name='quantity' onchange='quantitySelectorFromCart(${JSON.stringify(
              ProdInCart.id
            )})' >cus_select</select><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`;
            // quant_select.map((quantity) => {
            dynamic_quantity_selector({
              metafields,
            }).map((quantity) => {
              if (quantity.quantity === ProdInCart.quantity) {
                quantity_selector += `<option value='${quantity.quantity}' selected>${quantity.name}</option>`;
              } else {
                quantity_selector += `<option value='${quantity.quantity}'>${quantity.name}</option>`;
              }
            });
            quantitySelect = quantitySelect.replace(
              /cus_select/g,
              quantity_selector
            );
            productImage = localImages.replace(
              /imageURL/g,
              ProdInCart.featured_image.url
            );
            productOptions = localNames.replace(
              /name/g,
              findTitle?.metafield?.value || ProdInCart.product_title
            );
            var tag_price = ProdInCart.original_line_price / 100;
            let original_price = ProdInCart.original_price / 100;
            tag_price = tag_price - discount_percent * tag_price /100
            original_price = original_price - discount_percent *original_price/100
            let price_tag = `<span class='small-price-per-sqft' disabled>$${original_price.toFixed(2)}${
              metafields.find((item) => item?.key === "quantity_unit")
                ? "/" +
                  metafields.find((item) => item?.key === "quantity_unit").value
                : ""
            }</span>`;
            let finalProductPrice = `<p class='text'>$${tag_price.toFixed(
              2
            )}</p>`;

            let localProOptVal = proOptVal;
            let options = "";
            ProdInCart.options_with_values.map((PO_values) => {
              let findImgforPO = img_desc.find(
                (item) => item.title === PO_values.value
              );
              options += `<div class='variant-cta-logo'>${findImgforPO.imgURL}</div>`;
            });
            localProOptVal = localProOptVal.replace(/optVal/g, options);
            let productToUpdate = {
              quantity: ProdInCart.quantity,
              variant_id: ProdInCart.variant_id,
            };
            let btnForEditProduct = `<button class='options-cta' onclick='setupProductModal(${
              ProdInCart.product_id
            }, ${JSON.stringify(productToUpdate)},${JSON.stringify(
              ProdInCart.variant_options
            )},${discount_percent},"${DISCOUNT_TYPE}")'>edit options</button>`;
            const final_Cart_Data = `<div class="product-cart-card"><div class="for-whole-prod"><button class="remove-item-cta" onclick='deleteProduct(${JSON.stringify(
              ProdInCart.id
            )})'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.14258 10.1426C1.14258 15.1131 5.17201 19.1426 10.1426 19.1426C15.1131 19.1426 19.1426 15.1131 19.1426 10.1426C19.1426 5.17202 15.1131 1.14258 10.1426 1.14258C5.17201 1.14258 1.14258 5.17202 1.14258 10.1426Z" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 6.28516L10.0143 10.2709L6.02857 6.28516" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.02857 14.2572L10.0143 10.2715L14 14.2572" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></button><div class="whole-content"><div class="whole-image"><div class="product-cart-card-img">${productImage}</div></div><div class="whole-product-infro">${productOptions}${price_tag}<div class="variant-cta"><div class="variants-with-log">${localProOptVal}</div><div class="edit-variants">${btnForEditProduct}</div></div></div></div><div class="whole-quantity-and-price">${quantitySelect}<div class="whole-price">${finalProductPrice}</div></div></div></div>`;
            DOM.push(final_Cart_Data);
          }
        }
      } else {
        // This condition displays all the Sample Products Data on Cart
        if (ProdInCart.product_type == "sfe-stikwood") {
          var quantity_selector = "";
          let quantitySelect = `<div class='sample-selector'><select class="product-quantity" id='${
            ProdInCart.id
          }' class='cartselect' onchange='quantitySelectorFromCart(${JSON.stringify(
            ProdInCart.id
          )})' >cus_select</select><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`;
          // quantity_fanwall.map((quantity) => {
          dynamic_quantity_selector({
            metafields,
          }).map(({ quantity, name }) => {
            if (quantity === ProdInCart.quantity) {
              quantity_selector += `<option value='${quantity}' selected>${name}</option>`;
            } else {
              quantity_selector += `<option value='${quantity}'>${name}</option>`;
            }
          });
          quantitySelect = quantitySelect.replace(
            /cus_select/g,
            quantity_selector
          );

          productImage = localImages.replace(
            /imageURL/g,
            ProdInCart.featured_image.url
          );
          productOptions = localNames.replace(
            /name/g,
            findTitle?.metafield?.value || ProdInCart.product_title
          );

          var tag_price = ProdInCart.original_line_price / 100;
          let original_price = ProdInCart.original_price / 100;
          tag_price = tag_price - discount_percent * tag_price /100
          original_price = original_price - (discount_percent *original_price/100)
          let price_tag = `<span class='small-price' disabled>$${original_price.toFixed(2)}${
              metafields.find((item) => item?.key === "quantity_unit")
                ? "/" +
                  metafields.find((item) => item?.key === "quantity_unit").value
                : ""
            }</span>`;
          let finalProductPrice = `<p class='text'>$${tag_price.toFixed(2)}</p>`;

          // let productToUpdate = {
          //   quantity: ProdInCart.quantity,
          //   variant_id: ProdInCart.variant_id,
          //   final_line_price: ProdInCart.final_line_price,
          // };
          // let btnForEditProduct = `<button class='button button5 js-menu__open' data-menu="#main-nav" onclick='setupProductModal(${ProdInCart.product_id}, ${JSON.stringify(productToUpdate)},${JSON.stringify(ProdInCart.variant_options)} )'>Edit Options</button>`;
          const final_Cart_Data = `<div class="product-cart-card"><div class="for-whole-prod"><button class="remove-item-cta zeeshan" onclick='deleteProduct(${JSON.stringify(
            ProdInCart.id
          )})'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.14258 10.1426C1.14258 15.1131 5.17201 19.1426 10.1426 19.1426C15.1131 19.1426 19.1426 15.1131 19.1426 10.1426C19.1426 5.17202 15.1131 1.14258 10.1426 1.14258C5.17201 1.14258 1.14258 5.17202 1.14258 10.1426Z" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 6.28516L10.0143 10.2709L6.02857 6.28516" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.02857 14.2572L10.0143 10.2715L14 14.2572" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></button><div class="sample-content"><div class="sample-image"><div class="product-cart-card-img">${productImage}</div></div><div class="sample-title">${productOptions}${price_tag}</div></div><div class="sample-quantity-and-price">${quantitySelect}<div class="sample-price">${finalProductPrice}</div></div></div></div>`;

          DOM.push(final_Cart_Data);
        } else {
          var quantity_selector = "";
          let quantitySelect = `<div class='sample-selector'><select class="product-quantity" id='${
            ProdInCart.id
          }' class='cartselect' onchange='quantitySelectorFromCart(${JSON.stringify(
            ProdInCart.id
          )})' >cus_select</select><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L8.51731 9.0125L1 16.525" stroke="#372E2D" stroke-width="1.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`;
          // sample_quantity.map((quantity) => {
          dynamic_quantity_selector({
            metafields,
          }).map(({ quantity, name }) => {
            if (quantity === ProdInCart.quantity) {
              quantity_selector += `<option value='${quantity}' selected>${name}</option>`;
            } else {
              quantity_selector += `<option value='${quantity}'>${name}</option>`;
            }
          });
          quantitySelect = quantitySelect.replace(
            /cus_select/g,
            quantity_selector
          );

          productImage = localImages.replace(
            /imageURL/g,
            ProdInCart.featured_image.url
          );
          productOptions = localNames.replace(
            /name/g,
            findTitle?.metafield?.value || ProdInCart.product_title
          );

          var tag_price = ProdInCart.original_line_price / 100;
          let original_price = ProdInCart.original_price / 100;
          console.log("original_price",original_price,discount_percent,tag_price)
          
          tag_price = tag_price - discount_percent * tag_price /100
          original_price = original_price - discount_percent *original_price/100
          console.log("original_price2",original_price,discount_percent,tag_price)
          
          let price_tag = `<span class='small-price' disabled>$${original_price.toFixed(2)}${
              metafields.find((item) => item?.key === "quantity_unit")
                ? "/" +
                  metafields.find((item) => item?.key === "quantity_unit").value
                : ""
            }</span>`;
          let finalProductPrice = `<p class='text'>$${tag_price.toFixed(2)}</p>`;

          // let productToUpdate = {
          //   quantity: ProdInCart.quantity,
          //   variant_id: ProdInCart.variant_id,
          //   final_line_price: ProdInCart.final_line_price,
          // };
          // let btnForEditProduct = `<button class='button button5 js-menu__open' data-menu="#main-nav" onclick='setupProductModal(${ProdInCart.product_id}, ${JSON.stringify(productToUpdate)},${JSON.stringify(ProdInCart.variant_options)} )'>Edit Options</button>`;
          const final_Cart_Data = `<div class="product-cart-card"><div class="for-whole-prod"><button class="remove-item-cta zeeshan" onclick='deleteProduct(${JSON.stringify(
            ProdInCart.id
          )})'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.14258 10.1426C1.14258 15.1131 5.17201 19.1426 10.1426 19.1426C15.1131 19.1426 19.1426 15.1131 19.1426 10.1426C19.1426 5.17202 15.1131 1.14258 10.1426 1.14258C5.17201 1.14258 1.14258 5.17202 1.14258 10.1426Z" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M14 6.28516L10.0143 10.2709L6.02857 6.28516" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.02857 14.2572L10.0143 10.2715L14 14.2572" stroke="#372E2D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg></button><div class="sample-content"><div class="sample-image"><div class="product-cart-card-img">${productImage}</div></div><div class="sample-title">${productOptions}${price_tag}</div></div><div class="sample-quantity-and-price">${quantitySelect}<div class="sample-price">${finalProductPrice}</div></div></div></div>`;

          DOM.push(final_Cart_Data);
        }
      }
    });
    document.getElementById("cart_products_info").innerHTML = DOM.join("");
    let cartTotal = cartData.items_subtotal_price / 100;
    let subTotal = `$${cartTotal.toFixed(2)}`;
    document.getElementById("cart_total").innerHTML = subTotal;
  } else {
    // SELECTED_PRODUCT.options_to_update = []
    // SELECTED_PRODUCT.productObjToUpdate = {}
    // SELECTED_PRODUCT.product_data = {};
    // SELECTED_PRODUCT.cart_product_data = {}

    var itemCount = `${cartData.items.length}`;
    document.getElementById("itemCount").innerHTML = itemCount;
    document.getElementById("cus-cart").innerHTML = itemCount;
    let empCart = `<p>Your cart is currently empty.</p>`;
    document.getElementById("emptyCart").innerHTML = empCart;
    document.getElementById("cart_products_info").innerHTML = "";
    document.getElementById("cart_total").innerHTML = "$0";
  }
}

// // As soon as the Product Quantity Changes on Cart. This function will run and update the Quantity for Product and Sample Product
function quantitySelectorFromCart(prodToUpdate) {
  var count = document.getElementById(`${prodToUpdate}`).value;
  let variant_id = prodToUpdate;
  var myHeaders = new Headers();
  var formdata = new FormData();
  formdata.append("quantity", count);
  formdata.append("id", variant_id);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };
  fetch("/cart/change.js", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      custom_cart_data();
    })
    .catch((error) => console.log("error", error));
}

// This function is used to Delete the Product or Sample Product From the Cart.
function deleteProduct(variant_id) {
  var myHeaders = new Headers();

  var formdata = new FormData();
  formdata.append("quantity", 0);
  formdata.append("id", variant_id);
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };
  fetch("/cart/change.js", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      custom_cart_data();
    })
    .catch((error) => console.log("error", error));
}

function cartCheckout() {
  window.location = "/checkout";
}






